import {
  adminLogin,
  getConfigData,
  getPharms,
  getPharmData,
  updatePharm,
  deletePharm,
  getDrugs,
  getDrugData,
  createDrug,
  updateDrug,
  deleteDrug,
  getDatesAdmin,
  getServices,
  exportServices,
  getExportToken,
  updatePharmServices,
  removePharmService,
  updatePharmStaff,
  removePharmStaff,
  createPharm,
  removeProduct,
  createProduct,
  updateProduct,
  getDrugDosingRules,
  createDrugDosingRule,
  updateDrugDosingRule,
  deleteDrugDosingRule,
  getExportTokenForDrugs,
  getExportTokenForProbiotics,
  importProbiotics,
  getProbiotics,
  getProbioticData,
  createProbiotic,
  updateProbiotic,
  deleteProbiotic,
  getProbioticIndications,
  addProbioticIndication,
  updateProbioticIndication,
  removeProbioticIndication,
  getProbioticReviews,
  addProbioticReview,
  getProbioticMasterIndications,
  createProbioticMasterIndication,
  updateProbioticMasterIndication,
  getPharmProbiotics,
  importPharmProbiotics,
  linkPharmProbiotic,
  getLaboratories,
  createLaboratory,
  updateLaboratory,
  deleteLaboratory,
  getProbioticPresentations,
  createProbioticPresentation,
  updateProbioticPresentation,
  deleteProbioticPresentation,
  getProbioticDoses,
  createProbioticDose,
  updateProbioticDose,
  deleteProbioticDose,
  getReportedProbiotics,
  getProbiomentorConsultations,
  getMaterialsTree,
  createFolder,
  updateFolder,
  deleteFolder,
  uploadMaterials,
  uploadFolderCover,
  deleteMaterial,
  createFolderTree,
} from "../clients/farmavel/index";
import { farmavel } from "./repo/farmavel";

const version = "admin 2.0.7";
const page_vars = getUrlVars();
let page_lng = "es";

function get_absolute_url(url) {
  if (!url) {
    return "";
  }
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  const apiBase = farmavel.getBaseUrl();
  const serverBase = apiBase.endsWith("api/") ? apiBase.slice(0, -4) : apiBase;
  const cleanUrl = url.startsWith("/") ? url.slice(1) : url;
  return serverBase + cleanUrl;
}

import { repo } from "../repository/repo.js";

// Environment configuration
const getServerConfig = () => {
  const hostname = location.hostname;
  const isLocal = hostname === "localhost" || hostname.endsWith(".test");
  const isStaging = hostname.includes("staging");

  let baseUrl;
  if (isLocal) {
    baseUrl = "http://farmavel.test/";
  } else if (isStaging) {
    baseUrl = "https://farmaval-server-v2-staging.on-forge.com/";
  } else {
    baseUrl = "https://backend-v2.farmaval.net/";
  }

  return {
    base: baseUrl,
    endpoint: "admin_functions.php",
  };
};

const config = getServerConfig();
const server_base = config.base;
const server_url = server_base + config.endpoint;

// Authentication functions
function getSessionToken() {
  // Priorizar token de localStorage, luego URL parameter
  return (
    localStorage.getItem("farmaval_token") || page_vars["session_token"] || ""
  );
}

function saveSession(token, userData) {
  localStorage.setItem("farmaval_token", token);
  localStorage.setItem("farmaval_user", JSON.stringify(userData));
  // Guardar rol para compatibilidad con sesiones activas
  if (userData && userData.user_role) {
    localStorage.setItem("admin_user_role", userData.user_role);
  }
  // Guardar permisos para gating de menús (reemplaza gating por rol)
  localStorage.setItem(
    "admin_user_permissions",
    JSON.stringify(userData && userData.permissions ? userData.permissions : [])
  );
}

function clearSession() {
  localStorage.removeItem("farmaval_token");
  localStorage.removeItem("farmaval_user");
  localStorage.removeItem("admin_user_role");
  localStorage.removeItem("admin_user_permissions");
}

function getPermissions() {
  try {
    return JSON.parse(localStorage.getItem("admin_user_permissions") || "[]");
  } catch {
    return [];
  }
}

function userCan(perm) {
  // Superadmin tiene acceso completo a todo
  const role = localStorage.getItem("admin_user_role") || "";
  if (role === "superadmin") return true;

  const perms = getPermissions();
  return perms.includes(perm);
}

function getUser() {
  const userData = localStorage.getItem("farmaval_user");
  return userData ? JSON.parse(userData) : null;
}

function checkAuth() {
  const token = getSessionToken();
  if (!token) {
    showLogin();
    return false;
  }
  showApp();
  return true;
}

function showLogin() {
  document.getElementById("section_login").classList.add("visible");
  document.querySelector("nav").classList.add("hide");

  // Ocultar todas las demás secciones
  document
    .querySelectorAll("section:not(#section_login)")
    .forEach((section) => {
      section.classList.remove("visible");
    });

  // Asegurar que los listeners estén listos y los campos habilitados
  setupLoginListeners();
}

function apply_role_restrictions() {
  // Secciones core: visible solo si el usuario tiene permiso access-admin-core
  const coreSections = [
    "section_pharms",
    "section_services",
    "section_drugs",
    "section_products",
    "section_ergometrix",
    "section_actions",
    "section_dates",
  ];
  coreSections.forEach((section) => {
    const link = document.querySelector(`[aria-section="${section}"]`);
    if (link && !userCan("access-admin-core")) link.classList.add("hide");
  });

  // Menú Probióticos: visible si el usuario tiene manage-probiotics, make-probiotic-study o manage-laboratories
  const probLink = document.querySelector('[aria-section="section_probiotics"]');
  if (probLink && !userCan("manage-probiotics") && !userCan("make-probiotic-study") && !userCan("manage-laboratories") && !userCan("manage-probiotic-presentations") && !userCan("manage-probiotic-doses")) {
    probLink.classList.add("hide");
  }

  // Pestaña Laboratorios dentro de Probiomentor: solo con permiso manage-laboratories
  const labTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_labs"]');
  if (labTabLink && !userCan("manage-laboratories")) labTabLink.classList.add("hide");

  // Pestaña Pendientes de estudio dentro de Probiomentor: solo con permiso make-probiotic-study
  const pendingTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_pending"]');
  if (pendingTabLink && !userCan("make-probiotic-study")) pendingTabLink.classList.add("hide");

  // Pestaña Probióticos dentro de Probiomentor: solo con permiso manage-probiotics
  const probTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_probiotics"]');
  if (probTabLink && !userCan("manage-probiotics")) probTabLink.classList.add("hide");

  // Pestaña Presentaciones dentro de Probiomentor: solo con permiso manage-probiotic-presentations
  const presentationsTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_presentations"]');
  if (presentationsTabLink && !userCan("manage-probiotic-presentations")) presentationsTabLink.classList.add("hide");

  // Pestaña Dosis dentro de Probiomentor: solo con permiso manage-probiotic-doses
  const dosesTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_doses"]');
  if (dosesTabLink && !userCan("manage-probiotic-doses")) dosesTabLink.classList.add("hide");

  const indicationsTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_indications"]');
  if (indicationsTabLink && !userCan("manage-probiotics")) indicationsTabLink.classList.add("hide");

  // Pestaña Consultas de información: solo con permiso access-admin-core
  const consultasTabLink = document.querySelector('.probiomentor_tab_link[aria-tab="tab_probiomentor_consultas"]');
  if (consultasTabLink && !userCan("access-admin-core")) consultasTabLink.classList.add("hide");
}

function showApp() {
  document.getElementById("section_login").classList.remove("visible");
  document.querySelector("nav").classList.remove("hide");
  document.getElementById("nav_logout").classList.remove("hide");

  // Sección de aterrizaje según permisos del usuario
  if (userCan("access-admin-core")) {
    document.getElementById("section_pharms").classList.add("visible");
  } else if (userCan("manage-probiotics")) {
    document.getElementById("section_probiotics").classList.add("visible");
    setActiveProbiomentorTab("tab_probiomentor_probiotics");
    load_probiotics();
    load_lab_dropdown();
    load_format_dropdown();
  } else if (userCan("make-probiotic-study")) {
    document.getElementById("section_probiotics").classList.add("visible");
    setActiveProbiomentorTab("tab_probiomentor_pending");
    load_reported_probiotics();
  } else if (userCan("manage-laboratories")) {
    document.getElementById("section_probiotics").classList.add("visible");
    setActiveProbiomentorTab("tab_probiomentor_labs");
    load_laboratories();
  } else if (userCan("manage-probiotic-presentations")) {
    document.getElementById("section_probiotics").classList.add("visible");
    setActiveProbiomentorTab("tab_probiomentor_presentations");
    load_presentations();
    load_format_dropdown();
  } else if (userCan("manage-probiotic-doses")) {
    document.getElementById("section_probiotics").classList.add("visible");
    setActiveProbiomentorTab("tab_probiomentor_doses");
    load_doses();
  }

  apply_role_restrictions();
  setupLogoutListener();
}

async function doLogin(username, password) {
  // Validaciones
  if (!username || !password) {
    return {
      success: false,
      error: "Por favor ingrese usuario y contraseña",
    };
  }

  if (password.length < 6) {
    return {
      success: false,
      error: "La contraseña debe tener al menos 6 caracteres",
    };
  }

  try {
    const json = await adminLogin(username, password);

    if (!json || !json.status) {
      return {
        success: false,
        error: json?.message || json?.msg || "Error al iniciar sesión",
      };
    }

    // Guardar sesión (el SDK ya guarda el token en localStorage, pero mantenemos la compatibilidad con main.js)
    if (json.token) {
      saveSession(json.token, json.user || {});
      return {
        success: true,
        user: json.user,
        msg: json.msg || json.message,
      };
    } else {
      return {
        success: false,
        error: data?.msg || "Error al iniciar sesión",
      };
    }
  } catch (error) {
    console.error("Login error:", error);
    return {
      success: false,
      error: error.message || "Error de conexión con el servidor",
    };
  }
}

function doLogout() {
  clearSession();
  showLogin();
  // Recargar la página para limpiar todo el estado
  window.location.reload();
}

// Handle invalid session errors
function handleInvalidSession() {
  console.warn("Invalid session token detected. Logging out...");
  clearSession();
  alert("Su sesión ha expirado. Por favor inicie sesión nuevamente.");
  // Redirigir a la raíz sin parámetros para limpiar cualquier token inválido de la URL y recargar limpiamente
  const url = new URL(window.location.href);
  url.searchParams.delete("session_token");
  window.location.href = url.pathname + url.search;
}

// Wrapper for fetch with automatic session validation
async function fetchWithAuth(url, options = {}) {
  try {
    const response = await fetch(url, options);
    const json = await response.json();

    // Check for invalid session error - puede venir como json.error_session o dentro de json.error
    if (
      json &&
      (json.error_session === "Invalid token" ||
        (json.error &&
          typeof json.error === "string" &&
          json.error.includes("Invalid token")))
    ) {
      handleInvalidSession();
      return null;
    }

    return json;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

let loginListenersReady = false;
function setupLoginListeners() {
  const loginForm = document.getElementById("login_form");
  const loginButton = document.getElementById("btn_login");
  const loginError = document.getElementById("login_error");
  const loginUsername = document.getElementById("login_username");
  const loginPassword = document.getElementById("login_password");

  if (loginForm) {
    if (!loginListenersReady) {
      loginForm.addEventListener("submit", async function (e) {
        e.preventDefault();

        const username = loginUsername.value.trim();
        const password = loginPassword.value;

        // Limpiar error anterior
        loginError.classList.add("hide");
        loginError.textContent = "";

        // Deshabilitar botón y mostrar estado de carga
        loginButton.disabled = true;
        loginButton.classList.add("btn_loading");
        loginButton.textContent = "Iniciando sesión...";

        // Intentar login
        const result = await doLogin(username, password);

        if (result.success) {
          // Login exitoso - recargar la aplicación
          window.location.reload();
        } else {
          // Mostrar error
          loginError.textContent = result.error;
          loginError.classList.remove("hide");

          // Rehabilitar botón
          loginButton.disabled = false;
          loginButton.classList.remove("btn_loading");
          loginButton.textContent = "Iniciar sesión";
        }
      });
      loginListenersReady = true;
    }

    // Habilitar los campos del formulario una vez que los listeners estén configurados o si se vuelve a mostrar el login
    loginUsername.disabled = false;
    loginPassword.disabled = false;
    loginButton.disabled = false;
  }
}

function setupLogoutListener() {
  const logoutBtn = document.getElementById("nav_logout");
  if (logoutBtn) {
    logoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      doLogout();
    });
  }
}

function get_msg(msg) {
  const e = document.querySelector("[aria-msg=" + msg + "_" + page_lng + "]");
  if (e) return e.innerHTML;

  return "";
}
function show_lng(lng) {
  document.querySelectorAll(".lng").forEach((element) => {
    element.style.display = "none";
  });
  document.querySelectorAll(".lng_" + lng).forEach((element) => {
    element.style.display = "inline-block";
  });
  page_lng = lng;
  localStorage["wircos_lng"] = lng;
}

function lng_click(e) {
  var lng = this.getAttribute("href");
  show_lng(lng);
  e.preventDefault();
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(
    /[?&#]+([^=&#]+)=([^&#]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    },
  );
  return vars;
}

/**
 * Rellena una tabla con datos usando un template de fila
 * @param {string} tableId - ID del elemento tabla a rellenar
 * @param {Array} data - Array de objetos con los datos a mostrar
 * @param {string} subject - Prefijo para los IDs de las filas (ej: 'staff', 'pharm')
 * @param {Function|null} click_function - Función callback opcional al hacer click en una fila
 */
function fill_table(tableId, data, subject, click_function = null) {
  const table = document.getElementById(tableId);
  if (!table) {
    return;
  }

  const fieldIdAttribute = table.getAttribute("aria-id");
  const tableBody = table.querySelector("tbody");
  const tableHeader = table.querySelector("thead");
  const rowTemplateName = table.getAttribute("aria-row");
  const rowTemplate = document.querySelector("#elements ." + rowTemplateName);
  if (!rowTemplate || !tableBody || !tableHeader) {
    return;
  }

  // Limpiar tabla
  tableHeader.innerHTML = "";
  tableBody.innerHTML = "";

  const headerRow = createHeaderRow(rowTemplate);
  tableHeader.append(headerRow);

  data.forEach((rowData) => {
    const dataRow = createDataRow(
      rowTemplate,
      rowData,
      fieldIdAttribute,
      subject,
    );
    tableBody.append(dataRow);
  });

  if (click_function) {
    setupRowClickHandlers(table, tableBody, click_function);
  }
}

/**
 * Crea una fila de encabezado a partir del template
 * @param {HTMLElement} template - Elemento template a clonar
 * @returns {HTMLElement} Fila de encabezado con las etiquetas
 */
function createHeaderRow(template) {
  const headerRow = template.cloneNode(true);

  // Rellenar cada celda del header con su etiqueta (aria-label)
  for (const cell of headerRow.children) {
    const label = cell.getAttribute("aria-label");
    cell.innerHTML = label;
  }

  return headerRow;
}

/**
 * Crea una fila de datos a partir del template y un objeto de datos
 * @param {HTMLElement} template - Elemento template a clonar
 * @param {Object} rowData - Objeto con los datos de la fila
 * @param {string} fieldIdAttribute - Nombre del campo que contiene el ID único
 * @param {string} subject - Prefijo para el ID de la fila
 * @returns {HTMLElement} Fila con los datos poblados
 */
function createDataRow(template, rowData, fieldIdAttribute, subject) {
  const dataRow = template.cloneNode(true);

  // Configurar atributos de la fila
  const recordId = rowData[fieldIdAttribute];
  dataRow.setAttribute("aria-id", recordId);
  dataRow.setAttribute("id", subject + "_" + recordId);
  dataRow.setAttribute("aria-data", JSON.stringify(rowData));

  // Rellenar cada celda con su valor correspondiente
  for (const cell of dataRow.children) {
    const fieldName = cell.getAttribute("aria-field");
    const fieldValue = rowData[fieldName];

    if (fieldValue !== undefined && fieldValue !== null && fieldValue !== "") {
      populateCell(cell, fieldValue);
    }
  }

  return dataRow;
}

/**
 * Rellena una celda con su valor, manejando celdas tipo select
 * @param {HTMLElement} cell - Celda a rellenar
 * @param {*} value - Valor a mostrar en la celda
 */
function populateCell(cell, value) {
  if (cell.classList.contains("select")) {
    // Para celdas tipo select, mostrar la opción correspondiente
    const optionElement = cell.querySelector(".select_" + value);
    if (optionElement) {
      optionElement.classList.remove("hide");
    }
  } else {
    // Para celdas normales, insertar el valor directamente
    cell.innerHTML = value;
  }
}

/**
 * Configura los event listeners para hacer las filas clickeables
 * @param {HTMLElement} table - Elemento tabla
 * @param {HTMLElement} tableBody - Cuerpo de la tabla
 * @param {Function} clickCallback - Función a ejecutar al hacer click
 */
function setupRowClickHandlers(table, tableBody, clickCallback) {
  table.classList.add("table_hover");

  tableBody.querySelectorAll(".tr").forEach((row) => {
    row.addEventListener("click", function (e) {
      e.preventDefault();
      const rowId = row.getAttribute("aria-id");
      clickCallback(rowId, row);
    });
  });
}

async function load_list(params, to, count, click_function = null) {
  const { data: json } = await repo.get("admin/pharms", params);
  if (!json) {
    return;
  }
  if (!json.status) {
    alert("error: " + (json.message || json.error));
    return;
  }

  document.getElementById(count).innerText = json.data.length;

  const table = document.getElementById(to);
  const field_id = table.getAttribute("aria-id");
  const body = table.querySelector("tbody");
  const header = table.querySelector("thead");
  body.innerHTML = "";
  header.innerHTML = "";
  const from = document.querySelector(
    "#elements ." + table.getAttribute("aria-row"),
  );
  for (let a = 0; a <= json.data.length; a++) {
    let row = from.cloneNode(true);
    if (a > 0) {
      row.setAttribute("aria-id", json.data[a - 1][field_id]);
      row.setAttribute("id", "pharm_" + json.data[a - 1][field_id]);
    }
    for (const child of row.children) {
      if (a == 0) {
        child.innerHTML = child.getAttribute("aria-label");
      } else {
        if (json.data[a - 1][child.getAttribute("aria-field")]) {
          if (child.classList.contains("select")) {
            child
              .querySelector(
                ".select_" + json.data[a - 1][child.getAttribute("aria-field")],
              )
              .classList.remove("hide");
          } else
            child.innerHTML =
              json.data[a - 1][child.getAttribute("aria-field")];
        }
      }
    }
    if (a == 0) header.append(row);
    else body.append(row);
  }
  if (click_function) {
    table.classList.add("table_hover");
    body.querySelectorAll(".tr").forEach((element) => {
      element.addEventListener("click", function (e) {
        e.preventDefault();
        click_function(element.getAttribute("aria-id"));
      });
    });
  }
}

async function load_config() {
  const json = await getConfigData();

  if (!json) {
    return;
  }

  if (!json.status) {
    alert("error: " + (json.message || json.error));
    return;
  }

  if (json.ergo) options_to_ergo(json.ergo);

  if (json.pharms) {
    const sel = document.getElementById("filter_dates_pharm");
    if (sel) {
      sel.innerHTML = '<option value="0">Todas</option>';
      json.pharms.forEach((p) => {
        let option = new Option(p.pharm_name, p.pharm_id);
        sel.add(option);
      });
    }
  }

  if (json.ergometrix) {
    fill_table(
      "table_ergometrix",
      json.ergometrix,
      "ergometrix",
      function (data) {
        fill_info_from_table(
          "section_ergometrix",
          "ergometrix_field",
          "ergometrix_" + data,
          data,
        );
      },
    );
  }
  console.log("Products: ", json.products);
  if (json.products) {
    if (document.getElementById("filter_products_count"))
      document.getElementById("filter_products_count").innerText =
        json.products.length;
    fill_table("table_products", json.products, "prod", function (data, row) {
      // Se usa la fila clickeada directamente en vez de buscarla por id.
      // Hasta la unificación de idiomas prod_id no era único por fila, así que
      // era obligatorio; hoy ya lo es, pero pasar la fila sigue siendo más
      // barato que volver a recorrer el DOM.
      fill_info_from_table("section_products", "prod_field", row, data);
    });
  }
  if (json.actions) actions_to_table(json.actions);
  if (json.services) populate_services_options(json.services);
}

const buildServiceFilterLabel = (srvCode) => `Servicios ${srvCode}`

const populateSelectWithServices = (
    selectId,
    services,
    { allOption = null, allOptionAtEnd = false, labelFormatter = buildServiceFilterLabel } = {}
) => {
    const select = document.getElementById(selectId)
    if (!select) {
        return
    }

    select.innerHTML = ''

    if (allOption && !allOptionAtEnd) {
        select.add(new Option(allOption.label, allOption.value, false, !!allOption.selected))
    }

    services.forEach(({ srv_code: srvCode }) => {
        select.add(new Option(labelFormatter(srvCode), srvCode))
    })

    if (allOption && allOptionAtEnd) {
        select.add(new Option(allOption.label, allOption.value, false, !!allOption.selected))
    }
}

const populate_services_options = (services) => {
    if (!Array.isArray(services) || services.length === 0) {
        return
    }

    const psService = document.getElementById('ps_service')
    if (psService) {
        psService.innerHTML = ''
        services.forEach(({ srv_code: srvCode }) => {
            psService.add(new Option(srvCode, srvCode))
        })
    }

    populateSelectWithServices('filter_report_type', services, {
        allOption: { label: 'Todos', value: 'ALL' },
        allOptionAtEnd: true,
    })
    populateSelectWithServices('filter_services_type', services, {
        allOption: { label: 'Todos', value: 'ALL', selected: true },
        allOptionAtEnd: true,
    })

    populateSelectWithServices('filter_dates_service', services, {
        allOption: { label: 'Todos', value: '0' },
        labelFormatter: (srvCode) => srvCode,
    })

    const prodService = document.getElementById('prod_service')
    if (prodService) {
        prodService.innerHTML = ''
        services.forEach(({ srv_code: srvCode }) => {
            prodService.add(new Option(srvCode, srvCode.toLowerCase()))
        })
    }

    const materialsServices = document.querySelector('.materials_services_options')
    if (materialsServices) {
        materialsServices.innerHTML = ''
        services.forEach(({ srv_code: srvCode }) => {
            const label = document.createElement('label')
            const input = document.createElement('input')
            input.type = 'checkbox'
            input.className = 'mf_service_option'
            input.value = srvCode
            label.appendChild(input)
            label.append(` ${srvCode}`)
            materialsServices.appendChild(label)
        })
    }
}

async function load_data(params, field_class) {
  let json;
  if (params.function === "getPharmData") {
    json = await getPharmData(params.pharm);
  } else {
    json = await fetchWithAuth(server_url, {
      method: "post",
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + getSessionToken(),
      },
      body: JSON.stringify(params),
    });
  }

  if (!json) {
    return;
  }
  if (!json.status) {
    alert("error: " + (json.message || json.error));
    return;
  }

  const fields = document.querySelectorAll("." + field_class);
  fields.forEach((field) => {
    const fieldId = field.getAttribute("id");
    if (field.classList.contains("checklist")) value_to_checklist(field, null);
    else field.value = "";

    if (hasDefinedValue(json.data, fieldId)) {
      if (field.classList.contains("checklist"))
        value_to_checklist(field, json.data[fieldId]);
      else field.value = json.data[fieldId];
    }
  });

  const ags = document.querySelectorAll(".ag_field");
  ags.forEach((field) => {
    const fieldId = field.getAttribute("id");
    if (field.classList.contains("checklist")) value_to_checklist(field, null);
    else {
      if (field.tagName === "IMG")
        field.setAttribute("src", field.getAttribute("aria-default"));
      else field.value = "";
    }
    if (json.agreement) {
      if (hasDefinedValue(json.agreement, fieldId)) {
        if (field.tagName === "IMG") {
          field.setAttribute("src", json.agreement[fieldId]);
        } else field.value = json.agreement[fieldId];
      }
    }
  });

  document.getElementById("ag_pharm").value =
    document.getElementById("pharm_id").value;

  // services
  fill_table("table_ps", json.services, "ps", function (data) {
    fill_info_from_table("tab_pharm_services", "ps_field", "ps_" + data, data);
    // Actualizar opciones de ps_type según el servicio seleccionado (Etapa 04)
    const psServiceEl = document.getElementById("ps_service");
    if (psServiceEl) update_ps_type_options(psServiceEl.value);
  });

  // staff
  fill_table("table_staff", json.staff, "staff", function (data) {
    fill_info_from_table(
      "tab_pharm_staff",
      "staff_field",
      "staff_" + data,
      data,
    );
  });

  // actions
  fill_table("table_actions", json.actions, "action", function (data) {
    fill_info_from_table(
      "tab_pharm_actions",
      "action_field",
      "action_" + data,
      data,
    );
  });

  //ergo
  fill_table("table_ergo", json.ergo, "ergo", function (data) {
    fill_info_from_table("tab_pharm_ergo", "ergo_field", "ergo_" + data, data);
  });

  // probióticos de farmacia — Etapa 05
  const pharmIdForProbiotics = json.data?.pharm_id;
  if (pharmIdForProbiotics) {
    // El resumen del último import es de otra farmacia: se oculta al abrir la ficha
    clear_pharm_probiotics_import_result();
    load_pharm_probiotics(pharmIdForProbiotics);
  }

  if (json.data.group)
    document
      .getElementById("btn_view_agreement")
      .setAttribute("aria-group", json.data.group);
  else
    document.getElementById("btn_view_agreement").removeAttribute("aria-group");
}

async function load_drug_data(drug_id) {
  try {
    const json = await getDrugData(drug_id);

    if (!json) {
      return;
    }
    if (!json.status) {
      alert("error: " + (json.message || json.error));
      return;
    }

    console.log("drug data:", json);

    const fields = document.querySelectorAll(".drug_field");
    fields.forEach((field) => {
      if (field.classList.contains("checklist"))
        value_to_checklist(field, null);
      else field.value = "";

      if (
        json.data[field.getAttribute("id")] !== undefined &&
        json.data[field.getAttribute("id")] !== null
      ) {
        if (field.classList.contains("checklist"))
          value_to_checklist(field, json.data[field.getAttribute("id")]);
        else field.value = json.data[field.getAttribute("id")];
      }
    });

    setActiveDrugTab("tab_drug_data");
    await load_drug_dosing_rules(drug_id);
  } catch (error) {
    console.error("Error loading drug data:", error);
    alert("Error de conexión al cargar datos del medicamento");
  }
}

function fill_info_from_table(parent, field_class, row_id, id) {
  // row_id normalmente es un id de DOM (string) a buscar con getElementById.
  // Productos pasa la fila ya clickeada directamente. Era obligatorio cuando un
  // mismo prod_id tenía una fila por idioma; tras la unificación ya no lo es,
  // pero se mantiene porque evita una búsqueda innecesaria.
  const row =
    typeof row_id === "string" ? document.getElementById(row_id) : row_id;

  if (parent) {
    const parentElement = document.getElementById(parent);
    const previousSelected = parentElement.querySelector(".selected");
    if (previousSelected) previousSelected.classList.remove("selected");
    row.classList.add("selected");
  }

  document.getElementById(parent).setAttribute("aria-row", id);
  const data = JSON.parse(row.getAttribute("aria-data"));
  const fields = document.querySelectorAll("." + field_class);
  fields.forEach((field) => {
    const fieldId = field.getAttribute("id");
    let fieldValue = "";

    // Para campos que terminan en _utc (como ps_date_utc), si no existe,
    // intentar usar el campo sin el sufijo _utc (como ps_date)
    if (fieldId.endsWith("_utc") && !hasDefinedValue(data, fieldId)) {
      const baseFieldId = fieldId.slice(0, -4); // Remover '_utc'
      if (hasDefinedValue(data, baseFieldId)) {
        fieldValue = data[baseFieldId];
      }
    } else if (hasDefinedValue(data, fieldId)) {
      fieldValue = data[fieldId];
    }

    field.value = fieldValue;
  });
  change_btn_text(parent, false);
  if (document.getElementById(parent).querySelector(".btn_remove"))
    document
      .getElementById(parent)
      .querySelector(".btn_remove")
      .classList.remove("hide");
}

function options_to_ergo(options) {
  const sel = document.getElementById("ergo_desc");
  sel.innerHTML = "";
  options.forEach((e) => {
    let option = new Option(e.ergo_desc, e.ergo_desc);
    option.setAttribute("aria-data", JSON.stringify(e));
    sel.add(option);
  });
  sel.addEventListener("change", function (e) {
    const data = JSON.parse(
      this.options[this.selectedIndex].getAttribute("aria-data"),
    );
    const fields = document.querySelectorAll(".ergo_field");
    fields.forEach((field) => {
      const fieldId = field.getAttribute("id");
      if (hasDefinedValue(data, fieldId)) field.value = data[fieldId];
      else field.value = "";
    });
  });
}

function actions_to_table(actions) {
  fill_table("table_theactions", actions, "theaction", function (data) {
    fill_info_from_table(
      "section_actions",
      "action_field",
      "theaction_" + data,
      data,
    );
  });
}
function checklist_to_value(list) {
  let values = [];
  list.querySelectorAll(".checkbox_item input:checked").forEach((el) => {
    values.push(el.parentElement.getAttribute("aria-id"));
  });
  return values;
}
function value_to_checklist(list, value) {
  const fields = document.querySelectorAll(".checkbox_item");
  fields.forEach((el) => (el.querySelector("input").checked = false));

  if (!value) return;
  console.log(value);
  for (let a = 0; a < value.length; a++) {
    const input = list.querySelector(`[aria-id='${value[a]}'] input`);
    if (input) input.checked = true;
  }
}

function hasDefinedValue(data, key) {
  return (
    data &&
    Object.prototype.hasOwnProperty.call(data, key) &&
    data[key] !== undefined &&
    data[key] !== null
  );
}

function change_btn_text(parent, add) {
  if (!document.getElementById(parent).querySelector(".btn_text")) {
    if (add)
      document
        .getElementById(parent)
        .querySelector(".btn_update_fields")
        ?.classList.add("hide");
    else
      document
        .getElementById(parent)
        .querySelector(".btn_update_fields")
        ?.classList.remove("hide");
    return;
  }
  if (add) {
    document
      .getElementById(parent)
      .querySelector(".text_add")
      .classList.remove("hide");
    document
      .getElementById(parent)
      .querySelector(".text_update")
      .classList.add("hide");
  } else {
    document
      .getElementById(parent)
      .querySelector(".text_add")
      .classList.add("hide");
    document
      .getElementById(parent)
      .querySelector(".text_update")
      .classList.remove("hide");
  }
}

function empty_fields(parent, field_class) {
  document.getElementById(parent).setAttribute("aria-row", 0);
  const fields = document.querySelectorAll("." + field_class);
  fields.forEach((field) => {
    field.value = "";
  });
  change_btn_text(parent, true);
  if (document.getElementById(parent).querySelector(".btn_remove"))
    document
      .getElementById(parent)
      .querySelector(".btn_remove")
      .classList.add("hide");
  if (document.getElementById(parent).querySelector(".selected"))
    document
      .getElementById(parent)
      .querySelector(".selected")
      .classList.remove("selected");
}

function empty_all_fields() {
  empty_fields("tab_pharm_staff", "staff_field");
  empty_fields("tab_pharm_services", "ps_field");
  empty_fields("tab_pharm_actions", "action_field");
  empty_fields("tab_pharm_ergo", "ergo_field");
  empty_fields("section_ergometrix", "ergometrix_field");
  empty_fields("section_products", "prod_field");
  empty_fields("section_actions", "action_field");
}

function getCurrentDrugId() {
  const drugId = Number(
    document.getElementById("table_drugs")?.getAttribute("current_id"),
  );
  return Number.isInteger(drugId) && drugId > 0 ? drugId : 0;
}

function showNewDrugForm() {
  const tableDrugs = document.getElementById("table_drugs");
  if (tableDrugs) {
    tableDrugs.setAttribute("current_row", "");
    tableDrugs.setAttribute("current_id", 0);
  }

  document.getElementById("filter_drug_name").innerText = "Nuevo medicamento";

  empty_fields("tab_drug_data", "drug_field");
  resetDrugDosingRulesState(true);
  setActiveDrugTab("tab_drug_data");

  document.getElementById("btn_delete_drug").classList.add("hide");

  change_section("section", "section_drug_data", true);
}

function setActiveDrugTab(tabId = "tab_drug_data") {
  const currentTab = document.querySelector(".drug_tab_link.selected");
  if (currentTab) {
    currentTab.classList.remove("selected");
  }

  document
    .querySelector(`.drug_tab_link[aria-tab="${tabId}"]`)
    ?.classList.add("selected");

  change_section(".tab_drug", tabId, false);
}

function setDosingRuleSelectionState(isSelected) {
  const deleteButton = document.getElementById("btn_delete_drug_dosing_rule");
  if (!deleteButton) {
    return;
  }

  deleteButton.classList.remove("hide");
  deleteButton.classList.toggle("btn_disabled", !isSelected);
}

function extractDosingRulesList(response) {
  const normalizeDosingRule = (dosingRule = {}) => ({
    ...dosingRule,
    dosing_rule_id:
      dosingRule.dosing_rule_id || dosingRule.dudr_id || dosingRule.id || 0,
    puffs_per_dose:
      dosingRule.puffs_per_dose ?? dosingRule.dudr_puffs_per_dose ?? "",
    doses_per_day:
      dosingRule.doses_per_day ?? dosingRule.dudr_doses_per_day ?? "",
  });

  const list =
    (Array.isArray(response?.data) && response.data) ||
    (Array.isArray(response?.data?.rules) && response.data.rules) ||
    (Array.isArray(response?.list) && response.list) ||
    (Array.isArray(response?.dosing_rules) && response.dosing_rules) ||
    (Array.isArray(response?.data?.dosing_rules) &&
      response.data.dosing_rules) ||
    [];

  return list.map(normalizeDosingRule);
}

function extractDosingRuleId(response) {
  return (
    response?.dosing_rule_id ||
    response?.dudr_id ||
    response?.id ||
    response?.data?.dosing_rule_id ||
    response?.data?.dudr_id ||
    response?.data?.id ||
    response?.dosing_rule?.dosing_rule_id ||
    response?.dosing_rule?.dudr_id ||
    response?.dosing_rule?.id ||
    0
  );
}

function resetDrugDosingRulesState(clearTable = false) {
  if (!document.getElementById("tab_drug_dosing_rules")) {
    return;
  }

  empty_fields("tab_drug_dosing_rules", "dosing_rule_field");
  setDosingRuleSelectionState(false);

  if (clearTable) {
    fill_table("table_drug_dosing_rules", [], "dosing_rule");
  }
}

async function load_drug_dosing_rules(drugId) {
  resetDrugDosingRulesState(false);

  if (!drugId) {
    fill_table("table_drug_dosing_rules", [], "dosing_rule");
    return;
  }

  try {
    const response = await getDrugDosingRules(drugId);
    if (!response || !response.status) {
      const message =
        response?.message ||
        response?.error ||
        "Error al cargar pautas del medicamento";
      alert(message);
      fill_table("table_drug_dosing_rules", [], "dosing_rule");
      return;
    }

    const dosingRules = extractDosingRulesList(response);

    fill_table(
      "table_drug_dosing_rules",
      dosingRules,
      "dosing_rule",
      function (dosingRuleId) {
        fill_info_from_table(
          "tab_drug_dosing_rules",
          "dosing_rule_field",
          "dosing_rule_" + dosingRuleId,
          dosingRuleId,
        );
        setDosingRuleSelectionState(true);
      },
    );
  } catch (error) {
    console.error("Error loading drug dosing rules:", error);
    alert("Error de conexión al cargar pautas del medicamento");
  }
}

function clear_pharm_related_tables() {
  fill_table("table_ps", [], "ps");
  fill_table("table_staff", [], "staff");
  fill_table("table_actions", [], "action");
  fill_table("table_ergo", [], "ergo");
  const tbody = document.querySelector("#table_pharm_probiotics tbody");
  if (tbody) tbody.innerHTML = "";
  clear_pharm_probiotics_import_result();
}

/**
 * Oculta el resumen del último import y vacía la tabla de equivalencias: son de
 * la farmacia anterior y aceptarlas apuntaría a la farmacia equivocada.
 */
function clear_pharm_probiotics_import_result() {
  document.getElementById("pharm_probiotics_import_result")?.classList.add("hide");
  document.getElementById("pp_import_suggestions_block")?.classList.add("hide");
  const suggestions = document.querySelector("#table_pp_suggestions tbody");
  if (suggestions) suggestions.innerHTML = "";
}

/**
 * Escapa texto antes de inyectarlo con innerHTML. Los nombres de producto vienen
 * del Excel que sube la farmacia: no son de confianza.
 */
function escape_html(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Carga los probióticos de una farmacia en la tabla del admin.
 * Etapa 05 — Probiomentor.
 */
async function load_pharm_probiotics(pharmId) {
  try {
    const resp = await getPharmProbiotics(pharmId);
    const items = Array.isArray(resp?.data) ? resp.data : [];
    const tbody = document.querySelector("#table_pharm_probiotics tbody");
    if (!tbody) return;

    tbody.innerHTML = "";
    items.forEach((item) => {
      const tr = document.createElement("tr");
      tr.className = "tr";
      const inMatrix = item.pp_probiotic_id
        ? '<span style="color:green">✓ Sí</span>'
        : '<span style="color:#c0392b">⚠ No</span>';
      const active = item.pp_active
        ? '<span style="color:green">Activo</span>'
        : '<span style="color:#888">Inactivo</span>';
      tr.innerHTML = `
        <td class="td">${escape_html(item.pp_cn ?? "")}</td>
        <td class="td">${escape_html(item.pp_name ?? item.probiotic?.prob_name ?? "—")}</td>
        <td class="td">${item.pp_pvp != null ? escape_html(item.pp_pvp) + " €" : "—"}</td>
        <td class="td">${inMatrix}</td>
        <td class="td">${active}</td>
      `;
      tbody.appendChild(tr);
    });
  } catch (error) {
    console.error("Error cargando probióticos de farmacia:", error);
  }
}

/**
 * Pinta una lista de textos dentro de un bloque de resultado del import,
 * mostrándolo u ocultándolo según haya contenido.
 */
function fill_pharm_probiotics_import_block(blockId, listId, lines) {
  const block = document.getElementById(blockId);
  const list = document.getElementById(listId);
  if (!block || !list) return;

  list.innerHTML = "";
  if (!lines.length) {
    block.classList.add("hide");
    return;
  }

  lines.forEach((text) => {
    const row = document.createElement("div");
    row.className = "import_error_row";
    row.textContent = text;
    list.appendChild(row);
  });
  block.classList.remove("hide");
}

/** Texto de una fila pendiente de estudio, tal como se lista en el import. */
function pharm_probiotic_pending_label(item) {
  return item.name
    ? `CN ${item.cn} — ${item.name}`
    : `CN ${item.cn} — (sin nombre en el Excel)`;
}

/** Suma un delta a uno de los contadores del resumen del import. */
function bump_pharm_probiotics_stat(id, delta) {
  const node = document.getElementById(id);
  if (!node) return;
  node.textContent = Math.max(0, (parseInt(node.textContent, 10) || 0) + delta);
}

/** Clase del badge según lo fiable que sea la similitud. */
function pharm_probiotic_score_class(score) {
  if (score >= 95) return "pp_score_high";
  if (score >= 85) return "pp_score_mid";
  return "pp_score_low";
}

/** Etiqueta legible de un candidato de la guía. */
function pharm_probiotic_candidate_label(candidate) {
  const meta = [candidate.prob_cn ? `CN ${candidate.prob_cn}` : null, candidate.lab_name]
    .filter(Boolean)
    .join(" · ");
  const linked = candidate.already_linked ? " · ya en el catálogo" : "";
  return meta ? `${candidate.prob_name} (${meta}${linked})` : `${candidate.prob_name}${linked}`;
}

/** Candidato elegido en una fila de la tabla de equivalencias. */
function pharm_probiotic_choice(row) {
  const select = row.querySelector(".pp_suggestion_select");
  if (select) {
    const option = select.options[select.selectedIndex];
    return {
      probId: Number(select.value),
      score: Number(option?.dataset.score ?? 0),
      label: option?.dataset.label ?? "",
    };
  }

  const cell = row.querySelector(".pp_candidate");
  return {
    probId: Number(cell?.dataset.probId),
    score: Number(cell?.dataset.score ?? 0),
    label: cell?.dataset.label ?? "",
  };
}

/** Quita una fila de la tabla de equivalencias y oculta el bloque si se vacía. */
function drop_pharm_probiotic_suggestion(row) {
  const tbody = row.parentElement;
  row.remove();
  bump_pharm_probiotics_stat("pp_import_suggestions", -1);

  if (tbody && tbody.children.length === 0) {
    document.getElementById("pp_import_suggestions_block")?.classList.add("hide");
  }
}

/**
 * Tabla de equivalencias probables por nombre detectadas durante el import.
 *
 * Estas filas YA están guardadas como pendientes de estudio: aceptar solo las
 * vincula con la guía y rechazar las deja como están. Por eso no se pierde nada
 * si el usuario cierra la página sin decidir.
 */
function render_pharm_probiotics_suggestions(pharmId, suggestions, threshold) {
  const block = document.getElementById("pp_import_suggestions_block");
  const table = document.getElementById("table_pp_suggestions");
  const tbody = table?.querySelector("tbody");
  if (!block || !tbody) return;

  tbody.innerHTML = "";

  const hint = document.getElementById("pp_import_suggestions_hint");
  if (hint) {
    hint.textContent = suggestions.length
      ? `Similitud mínima ${threshold ?? 80}%. Acepta para vincular con la guía o rechaza para dejarlo pendiente de estudio.`
      : "";
  }

  if (!suggestions.length) {
    block.classList.add("hide");
    return;
  }

  suggestions.forEach((suggestion) => {
    const candidates = suggestion.candidates ?? [];
    if (!candidates.length) return;

    const tr = document.createElement("tr");
    tr.className = "tr";
    tr.dataset.ppId = suggestion.pp_id;
    tr.dataset.cn = suggestion.cn ?? "";
    tr.dataset.excelName = suggestion.excel_name ?? "";

    const best = candidates[0];
    const equivalence =
      candidates.length === 1
        ? `<div class="pp_candidate" data-prob-id="${best.prob_id}" data-score="${best.score}" data-label="${escape_html(best.prob_name)}">${escape_html(pharm_probiotic_candidate_label(best))}</div>`
        : `<select class="pp_suggestion_select">${candidates
            .map(
              (candidate) =>
                `<option value="${candidate.prob_id}" data-score="${candidate.score}" data-label="${escape_html(candidate.prob_name)}">${escape_html(pharm_probiotic_candidate_label(candidate))}</option>`
            )
            .join("")}</select>`;

    tr.innerHTML = `
      <td class="td">${escape_html(suggestion.cn ?? "—")}</td>
      <td class="td">${escape_html(suggestion.excel_name ?? "—")}</td>
      <td class="td">${suggestion.pvp != null ? escape_html(suggestion.pvp) + " €" : "—"}</td>
      <td class="td">${equivalence}</td>
      <td class="td"><span class="pp_score ${pharm_probiotic_score_class(best.score)}">${best.score}%</span></td>
      <td class="td pp_suggestion_actions">
        <div class="pp_suggestion_btns">
          <a href="#" class="btn_default btn_pp_accept">Aceptar</a>
          <a href="#" class="btn_default btn_warning btn_pp_reject">Rechazar</a>
        </div>
      </td>
    `;

    tbody.appendChild(tr);
  });

  if (!tbody.children.length) {
    block.classList.add("hide");
    return;
  }

  block.classList.remove("hide");
  bind_pharm_probiotics_suggestions(tbody, pharmId);
}

/**
 * Delegación de eventos de la tabla de equivalencias. El pharmId se guarda en el
 * tbody porque el listener sobrevive a los re-renders.
 */
function bind_pharm_probiotics_suggestions(tbody, pharmId) {
  tbody.dataset.pharmId = pharmId;

  if (tbody.dataset.bound === "1") return;
  tbody.dataset.bound = "1";

  tbody.addEventListener("change", (event) => {
    const select = event.target.closest(".pp_suggestion_select");
    if (!select) return;

    const row = select.closest("tr");
    const badge = row?.querySelector(".pp_score");
    const choice = pharm_probiotic_choice(row);
    if (!badge) return;

    badge.textContent = `${choice.score}%`;
    badge.className = `pp_score ${pharm_probiotic_score_class(choice.score)}`;
  });

  tbody.addEventListener("click", async (event) => {
    const accept = event.target.closest(".btn_pp_accept");
    const reject = event.target.closest(".btn_pp_reject");
    if (!accept && !reject) return;

    event.preventDefault();

    const row = (accept ?? reject).closest("tr");
    if (!row) return;

    if (reject) {
      // Se queda como estaba: pendiente de estudio para el especialista.
      const line = pharm_probiotic_pending_label({
        cn: row.dataset.cn || "—",
        name: row.dataset.excelName,
      });
      append_pharm_probiotics_pending_line(line);
      bump_pharm_probiotics_stat("pp_import_pending", 1);
      drop_pharm_probiotic_suggestion(row);
      return;
    }

    const choice = pharm_probiotic_choice(row);
    if (!choice.probId) return;

    const currentPharmId = tbody.dataset.pharmId;
    accept.classList.add("btn_loading");

    try {
      await linkPharmProbiotic(currentPharmId, row.dataset.ppId, choice.probId);
      drop_pharm_probiotic_suggestion(row);
      load_pharm_probiotics(currentPharmId);
    } catch (error) {
      console.error("Error vinculando el probiótico sugerido:", error);
      const message = error?.response?.data?.message;
      alert(message ? `No se pudo vincular: ${message}` : "No se pudo vincular el probiótico.");
    } finally {
      accept.classList.remove("btn_loading");
    }
  });
}

/** Añade una línea al bloque de pendientes de estudio y lo muestra si hacía falta. */
function append_pharm_probiotics_pending_line(text) {
  const block = document.getElementById("pp_import_pending_block");
  const list = document.getElementById("pp_import_pending_list");
  if (!block || !list) return;

  const row = document.createElement("div");
  row.className = "import_error_row";
  row.textContent = text;
  list.appendChild(row);
  block.classList.remove("hide");
}

/**
 * Muestra el resumen del import de probióticos de una farmacia.
 *
 * Las filas con equivalencia sugerida se cuentan aparte ("Por confirmar") y se
 * excluyen del bloque de pendientes de estudio para no listarlas dos veces.
 */
function render_pharm_probiotics_import_result(pharmId, data) {
  const notInMatrix = data.not_in_matrix ?? [];
  const errors = data.errors ?? [];
  const suggestions = data.suggestions ?? [];

  const suggestedIds = new Set(
    suggestions.map((item) => `${item.cn ?? ""}|${(item.excel_name ?? "").toLowerCase()}`)
  );
  const stillPending = notInMatrix.filter(
    (item) => !suggestedIds.has(`${item.cn ?? ""}|${(item.name ?? "").toLowerCase()}`)
  );

  document.getElementById("pp_import_new").textContent = data.imported ?? 0;
  document.getElementById("pp_import_updated").textContent = data.updated ?? 0;
  document.getElementById("pp_import_suggestions").textContent = suggestions.length;
  document.getElementById("pp_import_pending").textContent = stillPending.length;
  document.getElementById("pp_import_skipped").textContent = data.skipped ?? errors.length;

  render_pharm_probiotics_suggestions(pharmId, suggestions, data.match_threshold);

  fill_pharm_probiotics_import_block(
    "pp_import_pending_block",
    "pp_import_pending_list",
    stillPending.map(pharm_probiotic_pending_label)
  );

  fill_pharm_probiotics_import_block("pp_import_errors_block", "pp_import_errors_list", errors);

  document.getElementById("pharm_probiotics_import_result").classList.remove("hide");
}

/**
 * Importa probióticos de farmacia desde Excel.
 * Etapa 05 — Probiomentor. Columnas: CN, Nombre y PVP.
 */
async function import_pharm_probiotics(pharmId, file) {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const resp = await importPharmProbiotics(pharmId, formData);
    // La API devuelve contadores en la raíz; algunos endpoints envuelven en `data`.
    render_pharm_probiotics_import_result(pharmId, resp?.data ?? resp ?? {});
    load_pharm_probiotics(pharmId);
  } catch (error) {
    console.error("Error importando probióticos:", error);
    const message = error?.response?.data?.message;
    alert(
      message
        ? `Error al importar el archivo: ${message}`
        : "Error al importar el archivo. Revisa el formato (columnas CN, Nombre y PVP)."
    );
  }
}

/**
 *
 * @param {*} type ['section', '.tab_pharm'] (default: 'section')
 * @param {*} section ['section_pharms', 'tab_pharm_services', 'tab_pharm_actions', 'tab_pharm_ergo', 'section_ergometrix', 'section_products', 'section_actions']
 * @param {*} scroll [true, false] (default: true)
 */
function change_section(type, section, scroll = true) {
  document.querySelector(type + ".visible")?.classList.remove("visible");
  document.getElementById(section).classList.add("visible");
  if (scroll) window.scrollTo({ top: 0, behavior: "smooth" });

  if (section === "section_drugs") {
    load_drugs();
  } else if (section === "section_dates") {
    load_appointments();
  } else if (section === "section_probiotics") {
    const activeTab = document
      .querySelector(".probiomentor_tab_link.selected")
      ?.getAttribute("aria-tab");
    if (!activeTab || activeTab === "tab_probiomentor_probiotics") {
      load_probiotics();
      load_lab_dropdown();
      load_format_dropdown();
    } else if (activeTab === "tab_probiomentor_pending") {
      load_reported_probiotics();
    } else if (activeTab === "tab_probiomentor_labs") {
      load_laboratories();
    } else if (activeTab === "tab_probiomentor_presentations") {
      load_presentations();
    } else if (activeTab === "tab_probiomentor_doses") {
      load_doses();
    } else if (activeTab === "tab_probiomentor_indications") {
      load_master_indications();
    } else if (activeTab === "tab_probiomentor_consultas") {
      load_consultas();
    }
  } else if (section === "section_services") {
    load_pharms_for_filter();
  } else if (section === "section_materiales") {
    load_materials();
  }
}

async function update_fields_data(from) {
  let params = { function: from.getAttribute("aria-function"), data: {} };
  const field_class = from.getAttribute("aria-class");
  const resolveCurrentPharmId = () => {
    const currentTableId = document
      .getElementById("table_pharms")
      ?.getAttribute("current_id");
    const currentFieldId = document.getElementById("pharm_id")?.value;

    return [currentTableId, currentFieldId]
      .map((value) => Number(value))
      .find((value) => Number.isInteger(value) && value > 0);
  };

  // Recoleccion de datos de los campos correspondientes al objeto que se esta actualizando
  const fields = document.querySelectorAll("." + field_class);
  fields.forEach((field) => {
    if (!field.hasAttribute("aria-read-only")) {
      if (field.classList.contains("checklist"))
        params["data"][field.getAttribute("id")] = checklist_to_value(field);
      else params["data"][field.getAttribute("id")] = field.value;
    }
  });

  // Obtener el ID del item que se esta actualizando
  const itemId = document
    .getElementById(from.getAttribute("aria-parent"))
    .getAttribute("aria-row");

  params["row_id"] = itemId;

  let json;
  let response;
  try {
    // Actualizacion de datos de la farmacia
    if (params.function === "updatePharmData") {
      const pharmTable = document.getElementById("table_pharms");
      if (pharmTable) {
        params["pharm_id"] = pharmTable.getAttribute("current_id");
      }

      if (params.pharm_id == 0) {
        json = await createPharm(params.data);
      } else {
        json = await updatePharm(params.pharm_id, params.data);
      }
      pharmTable.setAttribute("current_id", json.pharm_id);
      // set the value of field with id pharm_id to the value of json.pharm_id
      document.getElementById("pharm_id").value = json.pharm_id;
    } else if (params.function === "updateDrugData") {
      // Actualizacion de datos del medicamento
      const drugTable = document.getElementById("table_drugs");
      if (drugTable) {
        params["drug_id"] = drugTable.getAttribute("current_id");
      }

      json =
        Number(params.drug_id) > 0
          ? await updateDrug(params.drug_id, params.data)
          : await createDrug(params.data);
    } else if (params.function === "updateProbioticData") {
      const probTable = document.getElementById("table_probiotics");
      if (probTable) {
        params["prob_id"] = probTable.getAttribute("current_id");
      }

      if (from.classList.contains("disabled")) return;
      const visibleSpan = from.querySelector('.btn_text:not(.hide)');
      const originalText = visibleSpan?.textContent;
      from.classList.add("disabled");
      if (visibleSpan) visibleSpan.textContent = "Guardando…";

      try {
        json =
          Number(params.prob_id) > 0
            ? await updateProbiotic(params.prob_id, params.data)
            : await createProbiotic(params.data);

        if (!json || !json.status) {
          alert("Error al guardar: " + (json?.message || "Error desconocido"));
          return;
        }

        // If newly created, update the current_id and heading
        if (!(Number(params.prob_id) > 0) && json.data?.prob_id) {
          probTable.setAttribute("current_id", json.data.prob_id);
          document.getElementById("btn_update_probiotic").querySelector(".text_add").classList.add("hide");
          document.getElementById("btn_update_probiotic").querySelector(".text_update").classList.remove("hide");
          document.getElementById("btn_delete_probiotic").classList.remove("hide");
          document.getElementById("filter_probiotic_name").innerText =
            params.data.prob_name || "Probiótico";
        }

        alert("Probiótico guardado. Ahora puedes completar sus indicaciones en la pestaña Indicaciones.");
        load_probiotics();
        return;
      } finally {
        from.classList.remove("disabled");
        if (visibleSpan && originalText) visibleSpan.textContent = originalText;
      }
    } else if (params.function === "updateDrugDosingRuleData") {
      const drugId = getCurrentDrugId();
      if (!drugId) {
        alert("Debes seleccionar un medicamento antes de guardar una pauta");
        return;
      }

      const puffsPerDose = Number(params.data.puffs_per_dose);
      const dosesPerDay = Number(params.data.doses_per_day);
      if (!Number.isInteger(puffsPerDose) || puffsPerDose < 1) {
        alert('El campo "Puffs por dosis" es obligatorio');
        return;
      }
      if (!Number.isInteger(dosesPerDay) || dosesPerDay < 1) {
        alert('El campo "Dosis por día" es obligatorio');
        return;
      }

      const payload = {
        puffs_per_dose: puffsPerDose,
        doses_per_day: dosesPerDay,
      };

      const dosingRuleId = Number(params.row_id);
      json =
        dosingRuleId > 0
          ? await updateDrugDosingRule(drugId, dosingRuleId, payload)
          : await createDrugDosingRule(drugId, payload);

      if (!json || !json.status) {
        let errorMessage =
          json?.message ||
          json?.error ||
          "Error al actualizar la pauta del medicamento";
        alert("Error: " + errorMessage);
        return;
      }

      await load_drug_dosing_rules(drugId);
      resetDrugDosingRulesState(false);

      alert("Datos actualizados");
      return;
    } else if (params.function === "updatePharmServices") {
      // Actualizacion de datos de los servicios de la farmacia
      const pharmId = resolveCurrentPharmId();
      if (!pharmId) {
        alert(
          "Debes seleccionar o guardar una farmacia antes de añadir servicios",
        );
        return;
      }

      json = await updatePharmServices({
        pharm_id: pharmId,
        row_id: params.row_id,
        ...params.data,
      });
    } else if (params.function === "updateStaff") {
      // Actualizacion de datos del personal de la farmacia
      const pharmId = resolveCurrentPharmId();
      if (!pharmId) {
        alert(
          "Debes seleccionar o guardar una farmacia antes de añadir personal",
        );
        return;
      }

      json = await updatePharmStaff({
        pharm_id: pharmId,
        row_id: params.row_id,
        ...params.data,
      });
    } else if (params.function === "updateProduct") {
      // Actualizacion de datos del producto
      const productTable = document.getElementById(
        from.getAttribute("aria-table"),
      );

      response = !!parseInt(itemId)
        ? await updateProduct(itemId, params.data)
        : await createProduct(params.data);

      json = response.data;
      json.status = response.status;

      document
        .getElementById(from.getAttribute("aria-parent"))
        .setAttribute("aria-row", json.product.prod_id);

      if (productTable) {
        productTable.setAttribute("current_id", json.product.prod_id);
        // set the value of field with id prod_id to the value of json.prod_id
      }
      if (document.getElementById("prod_id")) {
        document.getElementById("prod_id").value = json.product.prod_id;
      }
    } else {
      // Llamada a la API para actualizar otros datos legacy (ir migrando a los nuevos endpoints en farmavel)
      json = await fetchWithAuth(server_url, {
        method: "post",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getSessionToken(),
        },
        body: JSON.stringify(params),
      });
    }
  } catch (error) {
    // Manejar errores lanzados por el SDK (Axios) o la API de farmavel
    console.error("API Error:", error);
    let errorMessage = error.message || "Error en la petición";
    let errors = error.data?.errors || error.errors;

    if (errors && typeof errors === "object") {
      const errorDetails = [];
      Object.keys(errors).forEach((field) => {
        const fieldErrors = errors[field];
        if (Array.isArray(fieldErrors)) {
          fieldErrors.forEach((err) => {
            errorDetails.push(`• ${err}`);
          });
        } else if (typeof fieldErrors === "string") {
          errorDetails.push(`• ${fieldErrors}`);
        }
      });

      if (errorDetails.length > 0) {
        errorMessage = errorMessage + "\n\n" + errorDetails.join("\n");
      }
    }

    alert("Error: " + errorMessage);
    return;
  }

  // Si no hay respuesta de la API, salir
  if (!json) {
    return;
  }
  // Si la respuesta de la API no es exitosa, mostrar el mensaje de error
  if (!json.status) {
    let errorMessage =
      json.message || json.error || "Error al actualizar los datos";

    // Si hay errores de validación específicos, construir mensaje detallado para mostrar al usuario
    if (json.errors && typeof json.errors === "object") {
      const errorDetails = [];
      Object.keys(json.errors).forEach((field) => {
        const fieldErrors = json.errors[field];
        if (Array.isArray(fieldErrors)) {
          fieldErrors.forEach((error) => {
            errorDetails.push(`• ${error}`);
          });
        } else if (typeof fieldErrors === "string") {
          errorDetails.push(`• ${fieldErrors}`);
        }
      });

      if (errorDetails.length > 0) {
        errorMessage = errorMessage + "\n\n" + errorDetails.join("\n");
      }
    }

    alert("Error: " + errorMessage);
    return;
  }

  // Si la respuesta de la API es exitosa, mostrar la lista de productos
  if (json.list) {
    show_list(from.getAttribute("aria-table"), json.list);

    // Determinar el ID a seleccionar: si es nuevo registro usar el ID devuelto por la API
    let rowIdToSelect = params["row_id"];

    // Si es un nuevo registro de producto, usar el prod_id devuelto por la API
    if (params["row_id"] == 0 && json.staff_id) {
      rowIdToSelect = json.staff_id;
    }

    // Intentar seleccionar la fila actualizada o recién creada en la tabla de productos
    const rowElement = document
      .getElementById(from.getAttribute("aria-table"))
      .querySelector("[aria-id='" + rowIdToSelect + "']");

    if (rowElement) {
      rowElement.classList.add("selected");
      // Actualizar el aria-row del contenedor padre con el nuevo ID del producto
      document
        .getElementById(from.getAttribute("aria-parent"))
        .setAttribute("aria-row", rowIdToSelect);
    } else if (params["row_id"] == 0) {
      // Si es nuevo y no se encontró, vaciar los campos para permitir agregar otro producto
      empty_fields(
        from.getAttribute("aria-parent"),
        from.getAttribute("aria-class"),
      );
    }
  }

  // Si hay datos de ergometrix, actualizar los selectores de ergometrix
  if (json.ergo) options_to_ergo(json.ergo);

  if (json.group)
    document
      .getElementById("btn_view_agreement")
      .setAttribute("aria-group", json.group);
  else
    document.getElementById("btn_view_agreement").removeAttribute("aria-group");

  if (from.getAttribute("post-function")) {
    if (json.post_data)
      window[from.getAttribute("post-function")]?.(json.post_data);
  }

  alert("Datos actualizados");

  if (params.function === "updateDrugData") {
    empty_fields("tab_drug_data", "drug_field");
    change_section("section", "section_drugs", true);
  }

}


async function remove_item(from, parent, table, field, field_class) {
  const rowId = document
    .getElementById(from.getAttribute("aria-parent"))
    .getAttribute("aria-row");

  const functionName = from.getAttribute("aria-function");

  let json;
  let currentDrugId = 0;
  try {
    switch (functionName) {
      case "removePharmService":
        json = await removePharmService(rowId);
        break;
      case "removeStaff":
        json = await removePharmStaff(
          rowId,
          document
            .getElementById("table_pharms")
            .getAttribute("current_id"),
        );
        break;
      case "removeProduct":
        json = await removeProduct(rowId);
        break;
      case "deleteDrugDosingRule":
        currentDrugId = getCurrentDrugId();
        if (!currentDrugId) {
          alert("Debes seleccionar un medicamento antes de eliminar una pauta");
          return;
        }
        json = await deleteDrugDosingRule(currentDrugId, rowId);
        break;
      default:
        let params = {
          function: "removeItem",
          item_table: table,
          item_field: field,
        };
        params["row_id"] = rowId;
        params["pharm_id"] = document
          .getElementById("table_pharms")
          .getAttribute("current_id");
        console.log("Remove item:", params);

        json = await fetchWithAuth(server_url, {
          method: "post",
          mode: "cors",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + getSessionToken(),
          },
          body: JSON.stringify(params),
        });
    }
  } catch (error) {
    console.error("Error removing item:", error);
    alert("Error al eliminar el elemento: " + (error.message || error));
    return;
  }

  if (!json) {
    return;
  }
  if (!json.status) {
    alert("error: " + (json.message || json.error));
    return;
  }

  if (functionName === "deleteDrugDosingRule") {
    await load_drug_dosing_rules(currentDrugId);
    setDosingRuleSelectionState(false);
    alert("Item eliminado");
    return;
  }

  alert("Item eliminado");

  if (json.list) {
    show_list(from.getAttribute("aria-table"), json.list);
    // Después de eliminar y refrescar la lista, limpiamos los campos
    empty_fields(
      from.getAttribute("aria-parent"),
      from.getAttribute("aria-class"),
    );
  } else {
    document.getElementById(parent).querySelector(".selected").remove();
    empty_fields(parent, field_class);
  }
}

function show_list(table, list) {
  const tableElement = document.getElementById(table);
  const tab = tableElement?.getAttribute("aria-tab");
  if (!tab) {
    // Si no hay aria-tab, al menos intentamos refrescar la tabla si existe
    if (tableElement) {
      const field_class = tableElement.getAttribute("aria-field");
      fill_table(table, list, field_class);
    }
    return;
  }
  const field_class = tableElement.getAttribute("aria-field");
  fill_table(table, list, field_class, function (data, row) {
    // Se pasa la fila clickeada directamente en vez de reconstruir su id.
    // Ver fill_info_from_table(): heredado de cuando prod_id no era único.
    fill_info_from_table(tab, field_class + "_field", row, data);
  });
}

async function load_pharms(e) {
  if (e) e.preventDefault();
  const params = {
    sortby: document.getElementById("filter_sort").value,
    filterby: document.getElementById("filter_type").value,
    filter_value: document.getElementById("filter_value").value,
    filter_active: document.getElementById("filter_active").value,
  };

  try {
    const json = await getPharms(params);

    if (!json || !json.status) {
      alert(
        "error: " +
          (json?.message || json?.error || "Error al cargar farmacias"),
      );
      return;
    }

    document.getElementById("filter_pharms_count").innerText = json.data.length;

    // Populate agenda pharmacy filter
    const sel = document.getElementById("filter_dates_pharm");
    if (sel && sel.options.length <= 1) {
      sel.innerHTML = '<option value="0">Todas</option>';
      json.data.forEach((p) => {
        let option = new Option(p.pharm_name, p.pharm_id);
        sel.add(option);
      });
    }

    fill_table("table_pharms", json.data, "pharm", function (element) {
      const pharm_name = document.querySelector(
        "#table_pharms [aria-id='" +
          element +
          "'] " +
          "[aria-field='pharm_name']",
      ).innerText;
      document.getElementById("filter_pharm_name").innerText = pharm_name;

      document
        .getElementById("btn_update_pharm")
        .querySelector(".text_add")
        .classList.add("hide");
      document
        .getElementById("btn_update_pharm")
        .querySelector(".text_update")
        .classList.remove("hide");

      // Eliminar farmacia: solo sobre una farmacia existente y solo superadmin.
      // Si la sesión no guardó el rol (login por session_token en la URL) se
      // muestra igual: el backend es quien decide con un 403.
      const userRole = getUser()?.user_role;
      if (userRole === undefined || userRole === 1)
        document
          .getElementById("btn_delete_pharm")
          .classList.remove("hide");

      change_section("section", "section_pharm_data", true);
      document
        .getElementById("table_pharms")
        .setAttribute("current_row", "pharm_" + element);
      document
        .getElementById("table_pharms")
        .setAttribute("current_id", element);
      load_data({ function: "getPharmData", pharm: element }, "pharm_field");
    });
  } catch (error) {
    console.error("Error loading pharms:", error);
    alert("Error de conexión al cargar farmacias");
  }
}

async function load_drugs(e) {
  if (e) e.preventDefault();

  const params = {
    sort_by: document.getElementById("filter_drugs_sort").value,
    filter_by: document.getElementById("filter_drugs_type").value,
    filter_value: document.getElementById("filter_drugs_value").value,
    filter_active: document.getElementById("filter_drugs_active").value,
  };

  try {
    const json = await getDrugs(params);

    if (!json || !json.status) {
      alert(
        "error: " +
          (json?.message || json?.error || "Error al cargar medicamentos"),
      );
      return;
    }

    document.getElementById("filter_drugs_count").innerText = json.data.length;

    fill_table("table_drugs", json.data, "drug", function (element) {
      const drug_name = document.querySelector(
        "#table_drugs [aria-id='" +
          element +
          "'] " +
          "[aria-field='drug_name']",
      ).innerText;

      document.getElementById("filter_drug_name").innerText = drug_name;

      document
        .getElementById("btn_update_drug")
        .querySelector(".text_add")
        .classList.add("hide");
      document
        .getElementById("btn_update_drug")
        .querySelector(".text_update")
        .classList.remove("hide");

      document.getElementById("btn_delete_drug").classList.remove("hide");

      change_section("section", "section_drug_data", true);
      setActiveDrugTab("tab_drug_data");
      document
        .getElementById("table_drugs")
        .setAttribute("current_row", "drug_" + element);
      document
        .getElementById("table_drugs")
        .setAttribute("current_id", element);

      load_drug_data(element);
    });
  } catch (error) {
    console.error("Error loading drugs:", error);
    alert("Error de conexión al cargar medicamentos");
  }
}

// ─── PROBIOMENTOR — Etapa 01 ─────────────────────────────────────────────────

async function load_probiotics(e) {
  if (e) e.preventDefault();

  const params = {
    sort_by:            document.getElementById('filter_probiotics_sort').value,
    filter_active:      document.getElementById('filter_probiotics_active').value,
    filter_name:        document.getElementById('filter_prob_name')?.value?.trim()        || '',
    filter_cn:          document.getElementById('filter_prob_cn')?.value?.trim()          || '',
    filter_lab_id:      document.getElementById('filter_prob_lab_id')?.value              || '',
    filter_prob_presentation_id: document.getElementById('filter_prob_presentation_id')?.value || '',
    filter_evaluable:   document.getElementById('filter_prob_evaluable')?.value           ?? '',
    filter_review_from: document.getElementById('filter_prob_review_from')?.value         || '',
    filter_review_to:   document.getElementById('filter_prob_review_to')?.value           || '',
  };

  try {
    const json = await getProbiotics(params);
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar probióticos'));
      return;
    }

    document.getElementById('filter_probiotics_count').innerText = json.data.length;

    const probList = json.data.map((p) => ({
      ...p,
      prob_last_review_human: formatDateForProbiotics(p.prob_last_review),
    }));

    fill_table('table_probiotics', probList, 'prob', function (element) {
      const probName = document.querySelector(
        `#table_probiotics [aria-id='${element}'] [aria-field='prob_name']`
      )?.innerText || 'Probiótico';

      document.getElementById('filter_probiotic_name').innerText = probName;
      document.getElementById('btn_update_probiotic').querySelector('.text_add').classList.add('hide');
      document.getElementById('btn_update_probiotic').querySelector('.text_update').classList.remove('hide');
      document.getElementById('btn_delete_probiotic').classList.remove('hide');

      change_section('section', 'section_probiotic_data', true);
      setActiveProbioticTab('tab_probiotic_data');
      document.getElementById('table_probiotics').setAttribute('current_row', 'prob_' + element);
      document.getElementById('table_probiotics').setAttribute('current_id', element);

      load_probiotic_data(element);
    });
  } catch (error) {
    console.error('Error loading probiotics:', error);
    alert('Error de conexión al cargar probióticos');
  }
}

function setActiveProbioticTab(tabId = 'tab_probiotic_data') {
  document.querySelector('.probiotic_tab_link.selected')?.classList.remove('selected');
  document.querySelector(`.probiotic_tab_link[aria-tab="${tabId}"]`)?.classList.add('selected');
  change_section('.tab_probiotic', tabId, false);
}

function setActiveProbiomentorTab(tabId = 'tab_probiomentor_probiotics') {
  document.querySelector('.probiomentor_tab_link.selected')?.classList.remove('selected');
  document.querySelector(`.probiomentor_tab_link[aria-tab="${tabId}"]`)?.classList.add('selected');
  change_section('.tab_probiomentor', tabId, false);
}

function toggleExclusionReason(evaluable) {
  const field = document.getElementById('field_exclusion_reason');
  if (field) field.style.display = parseInt(evaluable) === 0 ? '' : 'none';
}

function toggleIndicationFormByEvaluable(evaluable) {
  const isNoEvaluable = parseInt(evaluable) === 0;
  const notice = document.getElementById('indication_no_evaluable_notice');
  const btn = document.getElementById('btn_save_probiotic_indication');
  const tab = document.getElementById('tab_probiotic_indications');
  if (notice) {
    if (isNoEvaluable) notice.classList.remove('hide'); else notice.classList.add('hide');
  }
  if (tab) {
    tab.querySelectorAll('.probiotic_indication_field').forEach((el) => {
      el.disabled = isNoEvaluable;
    });
  }
  if (btn) btn.disabled = isNoEvaluable;
}

async function load_probiotic_data(probiotic_id) {
  try {
    const json = await getProbioticData(probiotic_id);
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar datos del probiótico'));
      return;
    }

    document.querySelectorAll('.probiotic_field').forEach((field) => {
      field.value = '';
      const val = json.data[field.id];
      if (val !== undefined && val !== null) field.value = val;
    });

    toggleExclusionReason(parseInt(json.data.prob_evaluable ?? 1));
    toggleIndicationFormByEvaluable(parseInt(json.data.prob_evaluable ?? 1));
    setActiveProbioticTab('tab_probiotic_data');
    await load_probiotic_indications(probiotic_id);
    await load_probiotic_reviews(probiotic_id);

    // Inicializar formulario de revisión: fecha = hoy, nota = vacía
    const reviewDateInput = document.getElementById('pr_review_date');
    if (reviewDateInput) reviewDateInput.value = new Date().toISOString().split('T')[0];
    const reviewNoteInput = document.getElementById('pr_note');
    if (reviewNoteInput) reviewNoteInput.value = '';
  } catch (error) {
    console.error('Error loading probiotic data:', error);
    alert('Error de conexión al cargar datos del probiótico');
  }
}

function showNewProbioticForm() {
  const tbl = document.getElementById('table_probiotics');
  if (tbl) { tbl.setAttribute('current_row', ''); tbl.setAttribute('current_id', 0); }

  document.getElementById('filter_probiotic_name').innerText = 'Nuevo probiótico';
  empty_fields('tab_probiotic_data', 'probiotic_field');
  empty_fields('tab_probiotic_indications', 'probiotic_indication_field');
  document.getElementById('new_master_indication_block').classList.add('hide');
  fill_table('table_probiotic_indications', [], 'probiotic_indication');
  fill_table('table_probiotic_reviews', [], 'probiotic_review');

  document.getElementById('btn_delete_probiotic').classList.add('hide');
  document.getElementById('btn_update_probiotic').querySelector('.text_add').classList.remove('hide');
  document.getElementById('btn_update_probiotic').querySelector('.text_update').classList.add('hide');
  document.getElementById('btn_remove_probiotic_indication').classList.add('hide');
  document.getElementById('btn_save_probiotic_indication').querySelector('.text_add').classList.remove('hide');
  document.getElementById('btn_save_probiotic_indication').querySelector('.text_update').classList.add('hide');
  document.getElementById('tab_probiotic_indications').removeAttribute('current_link_id');

  toggleExclusionReason(1);
  toggleIndicationFormByEvaluable(1);
  setActiveProbioticTab('tab_probiotic_data');
  change_section('section', 'section_probiotic_data', true);
}


async function load_probiotic_indications(probiotic_id) {
  try {
    // Cargar maestras primero para que el dropdown esté listo
    await load_master_indications_dropdown();

    const json = await getProbioticIndications(probiotic_id);
    if (!json || !json.status) return;

    fill_table('table_probiotic_indications', json.data, 'probiotic_indication', function (linkId) {
      const row = document.querySelector(`#table_probiotic_indications [aria-id='${linkId}']`);
      if (!row) return;
      const data = JSON.parse(row.getAttribute('aria-data') || '{}');

      document.getElementById('pil_indication_id').value = data.pil_indication_id || '';
      document.getElementById('pil_evidence').value      = data.pil_evidence || '';
      document.getElementById('pil_dose_id').value       = data.pil_dose_id || '';
      document.getElementById('pil_pauta').value         = data.pil_pauta || '';
      document.getElementById('pil_population').value    = data.pil_population || '';
      document.getElementById('pil_notes').value         = data.pil_notes || '';
      document.getElementById('new_master_indication_block').classList.add('hide');

      document.getElementById('btn_remove_probiotic_indication').classList.remove('hide');
      document.getElementById('btn_save_probiotic_indication').querySelector('.text_add').classList.add('hide');
      document.getElementById('btn_save_probiotic_indication').querySelector('.text_update').classList.remove('hide');
      document.getElementById('tab_probiotic_indications').setAttribute('current_link_id', linkId);
    });
  } catch (error) {
    console.error('Error loading probiotic indications:', error);
  }
}

async function load_probiotic_reviews(probiotic_id) {
  try {
    const json = await getProbioticReviews(probiotic_id);
    if (!json || !json.status) return;

    const rows = json.data.map((review) => ({
      ...review,
      pr_review_date_human: formatDateForProbiotics(review.pr_review_date),
      pr_user_name: review.pr_user_name || 'Sistema',
    }));

    fill_table('table_probiotic_reviews', rows, 'probiotic_review');
  } catch (error) {
    console.error('Error loading probiotic reviews:', error);
  }
}

// ─── PROBIÓTICOS REPORTADOS POR FARMACIAS ────────────────────────────────────

async function load_reported_probiotics() {
  try {
    const json = await getReportedProbiotics();
    if (!json || !json.status) {
      alert('Error al cargar la cola de reportados: ' + (json?.message || 'Error desconocido'));
      return;
    }

    // Preparar datos para fill_table: añadir pharmacy_names como string legible
    const rows = json.data.map((item) => ({
      ...item,
      pharmacy_names: item.pharmacies?.map((p) => p.pharm_name).join(', ') || '—',
    }));

    fill_table('table_reported_probiotics', rows, 'reported_probiotics', function (cn) {
      // El aria-id de esta tabla es el CN (string), no un ID numérico
      const row = document.querySelector(`#table_reported_probiotics [aria-id='${cn}']`);
      if (!row) return;
      const data = JSON.parse(row.getAttribute('aria-data') || '{}');

      // Abrir el formulario de alta de la matriz PRECARGADO con los datos reportados
      showNewProbioticForm();
      document.getElementById('prob_cn').value      = data.cn   || '';
      document.getElementById('prob_name').value    = data.name || '';
      document.getElementById('prob_strains').value = data.strains || '';
      // Intentar preseleccionar la presentación por nombre si existe en el catálogo
      const presentationSelect = document.getElementById('prob_presentation_id');
      if (presentationSelect && data.format) {
        const formatLower = data.format.toLowerCase().trim();
        const matchOpt = Array.from(presentationSelect.options).find(
          (opt) => opt.textContent.toLowerCase().trim() === formatLower
        );
        if (matchOpt) presentationSelect.value = matchOpt.value;
      }
      // El lab_id no se puede precargar (la farmacia guardó texto, no el ID del laboratorio)
      // El usuario debe seleccionarlo en el desplegable al completar el estudio
      document.getElementById('filter_probiotic_name').innerText =
        `Estudio: ${data.name || data.cn}`;
    });
  } catch (error) {
    console.error('Error loading reported probiotics:', error);
    alert('Error de conexión al cargar los probióticos reportados');
  }
}

async function load_appointments(e) {
  if (e) e.preventDefault();

  const params = {
    pharm: document.getElementById("filter_dates_pharm").value,
    from: document.getElementById("filter_dates_from").value,
    to: document.getElementById("filter_dates_to").value,
    service: document.getElementById("filter_dates_service").value,
  };

  try {
    const json = await getDatesAdmin(params);

    if (!json || !json.status) {
      alert(
        "error: " + (json?.message || json?.error || "Error al cargar agenda"),
      );
      return;
    }

    // Transformar datos para que coincidan con la tabla
    const transformedData = json.data.map((item) => {
      const dateObj = new Date(item.date_date.replace(" ", "T"));
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();
      let hours = dateObj.getHours();
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");
      const seconds = String(dateObj.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 -> 12
      const hh = String(hours).padStart(2, "0");

      const formattedFullDate = `${day}/${month}/${year} ${hh}:${minutes}:${seconds} ${ampm}`;

      const patientName = item.patient
        ? `${item.patient.patient_surname_1 || ""} ${
            item.patient.patient_surname_2 || ""
          }, ${item.patient.patient_name || ""}`.trim()
        : item.date_fullname || "";

      return {
        ...item,
        app_id: item.date_id,
        pharm_name: item.pharm ? item.pharm.pharm_name : "",
        patient_name: patientName,
        service_name: item.date_service,
        app_date: formattedFullDate,
        app_time: "",
      };
    });

    document.getElementById("filter_dates_count").innerText = json.data.length;

    fill_table("table_dates", transformedData, "app");
  } catch (error) {
    console.error("Error loading appointments:", error);
    alert("Error de conexión al cargar agenda");
  }
}

async function load_services(e) {
  if (e) e.preventDefault();

  const params = {
    pharm_id: document.getElementById("filter_services_pharm").value,
    from: document.getElementById("filter_services_from").value,
    to: document.getElementById("filter_services_to").value,
    service: document.getElementById("filter_services_type").value,
  };

  try {
    const json = await getServices(params);

    if (!json || !json.status) {
      alert(
        "error: " +
          (json?.message || json?.error || "Error al cargar servicios"),
      );
      return;
    }

    document.getElementById("filter_services_count").innerText =
      json.data.length;

    // Transformar datos siguiendo el formato del backend
    const transformedData = json.data.map((item) => {
      // Manejar fechas si vienen como rep_start
      let date = "";
      let time = "";
      if (item.rep_start) {
        const dateObj = new Date(item.rep_start.replace(" ", "T"));
        if (!isNaN(dateObj.getTime())) {
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = dateObj.getFullYear();
          const hours = String(dateObj.getHours()).padStart(2, "0");
          const minutes = String(dateObj.getMinutes()).padStart(2, "0");
          date = `${day}/${month}/${year}`;
          time = `${hours}:${minutes}`;
        }
      }

      // Manejar datos del reporte/servicio
      const repData = item.rep_data
        ? typeof item.rep_data === "string"
          ? JSON.parse(item.rep_data)
          : item.rep_data
        : {};

      return {
        ...item,
        rep_id: item.id || item.rep_id || 0,
        pharmacy:
          item.pharmacy ||
          item.pharm_name ||
          (item.pharm ? item.pharm.pharm_name : ""),
        service: item.service || item.rep_service || item.service_name || "",
        date: item.date || date,
        time: item.time || time,
        duration:
          item.duration !== undefined
            ? item.duration
            : item.rep_duration
              ? Math.round(item.rep_duration / 60)
              : 0,
        patient:
          item.patient ||
          item.patient_name ||
          (item.patient_obj
            ? `${item.patient_obj.patient_surname_1 || ""} ${item.patient_obj.patient_surname_2 || ""}, ${item.patient_obj.patient_name || ""}`.trim()
            : ""),
        technician:
          item.technician ||
          item.technical_name ||
          (item.staff ? item.staff.staff_name : ""),
        visit:
          item.visit || repData.service_visit || repData.inhaler_visit || "",
        real:
          item.real ||
          repData.service_visit_real ||
          repData.patient_visit ||
          "",
        sales:
          item.sales !== undefined
            ? item.sales
            : `${item.sales_sum_sale_total || 0}€`,
        inhaler:
          item.inhaler || repData.service_drug || repData.inhaler_name || "",
      };
    });

    fill_table("table_reports", transformedData, "report");
  } catch (error) {
    console.error("Error loading services:", error);
    alert("Error de conexión al cargar servicios");
  }
}

async function load_pharms_for_filter() {
  const normalizePharm = (pharm) => ({
    id: pharm?.pharm_id ?? pharm?.id ?? "",
    name: pharm?.pharm_name ?? pharm?.name ?? "",
  });

  try {
    const response = await getPharms({
      sort_by: "pharm_name",
      active: 1,
    });
    const pharms = Array.isArray(response?.data)
      ? response.data.map(normalizePharm)
      : [];

    const select = document.getElementById("filter_services_pharm");
    if (!select) return;

    select.innerHTML = '<option value="">Todas las farmacias</option>';

    pharms.forEach((pharm) => {
      const option = document.createElement("option");
      option.value = pharm.id;
      option.textContent = pharm.name;
      select.appendChild(option);
    });
  } catch (error) {
    console.error("Error loading service pharmacies filter:", error);
  }
}

/**
 * Actualiza las opciones del select ps_type según el servicio seleccionado.
 * PROBIOMENTOR usa modalidades específicas (360 / INTENSIVO).
 * Otros servicios usan modalidades genéricas (0-4).
 * (Etapa 04 — Probiomentor)
 */
function update_ps_type_options(service) {
  const psType = document.getElementById("ps_type");
  if (!psType) return;

  const currentVal = psType.value;

  if (service === "PROBIOMENTOR") {
    psType.innerHTML =
      '<option value="360">360 (Programa completo)</option>' +
      '<option value="INTENSIVO">INTENSIVO (Programa corto 3 meses)</option>';
    if (["360", "INTENSIVO"].includes(currentVal)) psType.value = currentVal;
  } else {
    psType.innerHTML =
      '<option value="0">On-line privada</option>' +
      '<option value="1">On-line dual</option>' +
      '<option value="2">On-line grupal</option>' +
      '<option value="3">On-line presencial</option>' +
      '<option value="4">Blended</option>';
    if (["0", "1", "2", "3", "4"].includes(currentVal)) psType.value = currentVal;
  }
}

// ============ Material Divulgativo ============
// Carpetas anidables sin límite de profundidad; solo la carpeta raíz puede
// restringirse por servicio (SATI/IRETIA/CEPOC/PROBIOMENTOR). Las subcarpetas
// heredan la visibilidad de su raíz. Ver farmavel: MaterialController.

let materialsTreeCache = []
let materialsUploadTargetFolderId = null // carpeta destino de "Subir archivos"
let materialsTreeUploadParentId = null // carpeta destino (null = raíz) de "Subir árbol"
const materialsFolderCollapseState = {}
let materialsCoverPreviewObjectUrl = null

// farmavel.js (_handleError) rechaza la promesa con un objeto plano
// {message, status, data} para cualquier respuesta HTTP no-2xx (p.ej. un 422
// de validación) — nunca llega a resolverse como {status:false,...}. Por eso
// los catch de esta sección muestran error?.message (el mensaje real del
// backend) en vez de un texto genérico.
function materialsErrorMessage(error, fallback) {
    return error?.message || fallback
}

// El backend valida cada archivo del lote con claves tipo "files.6" (posición
// dentro del FormData enviado), pero esa posición no significa nada para el
// usuario. Esta función cruza esas claves con el array de `files` del mismo
// lote para mostrar el nombre (o ruta relativa, si viene de un árbol de
// carpetas) del archivo real que falló, en vez de un índice numérico.
function describeMaterialsUploadError(error, files) {
    const errors = error?.data?.errors
    if (!errors || typeof errors !== 'object') return null

    const messages = Object.keys(errors)
        .map((field) => {
            const match = field.match(/^files\.(\d+)/)
            const file = match ? files[Number(match[1])] : null
            const fileLabel = file
                ? file.webkitRelativePath || file.name
                : match
                  ? `archivo #${Number(match[1]) + 1}`
                  : null

            const fieldErrors = errors[field]
            const fieldMessage = Array.isArray(fieldErrors)
                ? fieldErrors.join(' ')
                : String(fieldErrors)

            return fileLabel ? `• "${fileLabel}": ${fieldMessage}` : `• ${fieldMessage}`
        })
        .filter(Boolean)

    return messages.length > 0 ? messages.join('\n') : null
}

async function load_materials() {
    try {
        const json = await getMaterialsTree()

        if (!json || !json.status) {
            alert(
                'error: ' +
                    (json?.message ||
                        'Error al cargar material divulgativo')
            )
            return
        }

        materialsTreeCache = json.data || []
        render_materials_tree()
    } catch (error) {
        console.error('Error loading materials:', error)
        alert(
            'error: ' +
                materialsErrorMessage(
                    error,
                    'Error de conexión al cargar material divulgativo'
                )
        )
    }
}

function render_materials_tree() {
    const container = document.getElementById('materials_tree')
    if (!container) return

    container.innerHTML = ''

    if (materialsTreeCache.length === 0) {
        const empty = document.createElement('div')
        empty.className = 'materials_empty'
        empty.textContent =
            'Todavía no hay carpetas de material divulgativo.'
        container.appendChild(empty)
        return
    }

    materialsTreeCache.forEach((folder) => {
        container.appendChild(render_material_folder_node(folder))
    })
}

function get_material_folder_total_files(folder) {
    const ownFiles = Array.isArray(folder.files) ? folder.files.length : 0
    const childrenFiles = Array.isArray(folder.children)
        ? folder.children.reduce(
              (sum, child) => sum + get_material_folder_total_files(child),
              0
          )
        : 0
    return ownFiles + childrenFiles
}

function folder_has_collapsible_content(folder) {
    const hasFiles = Array.isArray(folder.files) && folder.files.length > 0
    const hasChildren =
        Array.isArray(folder.children) && folder.children.length > 0
    return hasFiles || hasChildren
}

function is_material_folder_expanded(folder) {
    const folderId = String(folder.id)
    if (!(folderId in materialsFolderCollapseState)) {
        materialsFolderCollapseState[folderId] = false
    }

    return materialsFolderCollapseState[folderId]
}

function toggle_material_folder(folderId) {
    const key = String(folderId)
    materialsFolderCollapseState[key] = !materialsFolderCollapseState[key]
    render_materials_tree()
}

function render_material_folder_node(folder) {
    const isRoot = folder.parent_id === null
    const totalFiles = get_material_folder_total_files(folder)
    const isCollapsible = folder_has_collapsible_content(folder)
    const isExpanded = isCollapsible
        ? is_material_folder_expanded(folder)
        : true

    const node = document.createElement('div')
    node.className = 'materials_node'
    node.setAttribute('data-folder-id', folder.id)

    const header = document.createElement('div')
    header.className = 'materials_node_header'

    const identity = document.createElement('div')
    identity.className = 'materials_node_identity'

    if (isCollapsible) {
        const toggle = document.createElement('button')
        toggle.type = 'button'
        toggle.className = 'materials_toggle_btn'
        toggle.textContent = isExpanded ? '▾' : '▸'
        toggle.setAttribute(
            'aria-label',
            isExpanded ? 'Colapsar carpeta' : 'Expandir carpeta'
        )
        toggle.addEventListener('click', () => toggle_material_folder(folder.id))
        identity.appendChild(toggle)
    } else {
        const spacer = document.createElement('span')
        spacer.className = 'materials_toggle_spacer'
        identity.appendChild(spacer)
    }

    const icon = document.createElement('span')
    icon.className = 'materials_folder_icon'
    icon.innerHTML = `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M3 6.75A2.75 2.75 0 0 1 5.75 4h4.086a2.75 2.75 0 0 1 1.944.806l1.414 1.414c.258.258.607.403.972.403h4.084A2.75 2.75 0 0 1 21 9.373v7.877A2.75 2.75 0 0 1 18.25 20H5.75A2.75 2.75 0 0 1 3 17.25V6.75Zm2.75-1.25a1.25 1.25 0 0 0-1.25 1.25v.873h13.75a2.74 2.74 0 0 1 1.25.3v-1.05a1.25 1.25 0 0 0-1.25-1.25h-4.084a2.75 2.75 0 0 1-1.944-.806L10.808 4.4a1.25 1.25 0 0 0-.884-.366H5.75Z" />
        </svg>
    `
    identity.appendChild(icon)

    const name = document.createElement('span')
    name.className = 'materials_node_name'
    name.textContent = `${folder.name} (${totalFiles})`
    identity.appendChild(name)

    header.appendChild(identity)

    if (isRoot) {
        if (folder.services && folder.services.length > 0) {
            folder.services.forEach((service) => {
                const tag = document.createElement('span')
                tag.className = 'materials_service_tag'
                tag.textContent = service
                header.appendChild(tag)
            })
        } else {
            const tag = document.createElement('span')
            tag.className = 'materials_service_tag materials_service_tag_all'
            tag.textContent = 'Todas las farmacias'
            header.appendChild(tag)
        }
    }

    const actions = document.createElement('div')
    actions.className = 'materials_node_actions'

    actions.appendChild(
        make_materials_action_link('+ Subcarpeta', () =>
            show_material_folder_form(null, folder.id)
        )
    )
    actions.appendChild(
        make_materials_action_link('Subir archivos', () => {
            materialsUploadTargetFolderId = folder.id
            document.getElementById('input_upload_materials').click()
        })
    )
    actions.appendChild(
        make_materials_action_link('Subir árbol aquí', () => {
            materialsTreeUploadParentId = folder.id
            document.getElementById('input_upload_tree').click()
        })
    )
    actions.appendChild(
        make_materials_action_link('Editar', () =>
            show_material_folder_form(folder)
        )
    )
    actions.appendChild(
        make_materials_action_link(
            'Eliminar',
            () => delete_material_folder_prompt(folder),
            'materials_link_danger'
        )
    )

    header.appendChild(actions)
    node.appendChild(header)

    if (isCollapsible) {
        const body = document.createElement('div')
        body.className = 'materials_node_body' + (isExpanded ? '' : ' hide')

        if (folder.files && folder.files.length > 0) {
            const files = document.createElement('div')
            files.className = 'materials_files'
            folder.files.forEach((file) => {
                files.appendChild(render_material_file_row(file))
            })
            body.appendChild(files)
        }

        if (folder.children && folder.children.length > 0) {
            const children = document.createElement('div')
            children.className = 'materials_node_children'
            folder.children.forEach((child) => {
                children.appendChild(render_material_folder_node(child))
            })
            body.appendChild(children)
        }

        node.appendChild(body)
    }

    return node
}

function make_materials_action_link(text, onClick, extraClass) {
    const a = document.createElement('a')
    a.href = '#'
    a.className =
        'materials_action_link' + (extraClass ? ' ' + extraClass : '')
    a.textContent = text
    a.addEventListener('click', (e) => {
        e.preventDefault()
        onClick()
    })
    return a
}

function render_material_file_row(file) {
    const row = document.createElement('div')
    row.className = 'materials_file_row'

    const link = document.createElement('a')
    link.href = get_absolute_url(file.url)
    link.target = '_blank'
    link.textContent = file.name

    const del = make_materials_action_link(
        'Eliminar',
        () => delete_material_file_prompt(file),
        'materials_link_danger'
    )

    row.appendChild(link)
    row.appendChild(del)
    return row
}

function show_material_folder_form(folder, parentIdForNew = null) {
    const form = document.getElementById('material_folder_form')
    form.classList.remove('hide')

    const isRoot = folder ? folder.parent_id === null : parentIdForNew === null

    document.getElementById('mf_id').value = folder ? folder.id : ''
    document.getElementById('mf_parent_id').value = folder
        ? ''
        : parentIdForNew ?? ''
    document.getElementById('mf_name').value = folder ? folder.name : ''
    document.getElementById('mf_cover').value = ''
    update_material_cover_preview(get_absolute_url(folder?.cover_url || null))

    document
        .getElementById('mf_services_field')
        .classList.toggle('hide', !isRoot)

    document.querySelectorAll('.mf_service_option').forEach((checkbox) => {
        checkbox.checked = !!(
            folder &&
            folder.services &&
            folder.services.includes(checkbox.value)
        )
    })

    document
        .getElementById('btn_delete_material_folder')
        .classList.toggle('hide', !folder)

    form.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

function hide_material_folder_form() {
    document.getElementById('material_folder_form').classList.add('hide')
    document.getElementById('mf_cover').value = ''
    update_material_cover_preview(null)
}

async function save_material_folder(e) {
    e.preventDefault()

    const id = document.getElementById('mf_id').value
    const parentId = document.getElementById('mf_parent_id').value
    const name = document.getElementById('mf_name').value.trim()
    const coverFile = document.getElementById('mf_cover').files?.[0]

    if (!name) {
        alert('El nombre de la carpeta es obligatorio')
        return
    }

    const services = Array.from(
        document.querySelectorAll('.mf_service_option:checked')
    ).map((el) => el.value)

    try {
        const response = id
            ? await updateFolder(id, { mf_name: name, services })
            : await createFolder({
                  mf_name: name,
                  mf_parent_id: parentId ? Number(parentId) : null,
                  services,
              })

        if (!response || !response.status) {
            alert(
                'error: ' +
                    (response?.message || 'No se pudo guardar la carpeta')
            )
            return
        }

        const folderId = Number(id || response?.data?.mf_id || response?.data?.id)
        if (coverFile && folderId) {
            await upload_material_cover_to_folder(folderId, coverFile)
        }

        hide_material_folder_form()
        await load_materials()
    } catch (error) {
        console.error('Error saving material folder:', error)
        alert(
            'error: ' +
                materialsErrorMessage(
                    error,
                    'Error de conexión al guardar la carpeta'
                )
        )
    }
}

function delete_material_folder_prompt(folder) {
    const res = window.prompt(
        "Teclea 'eliminar' para confirmar — se borrará la carpeta, sus subcarpetas y archivos"
    )
    if (res === 'eliminar') delete_material_folder_by_id(folder.id)
    else alert('Eliminación cancelada')
}

async function delete_material_folder_by_id(id) {
    try {
        const response = await deleteFolder(id)

        if (!response || !response.status) {
            alert(
                'error: ' +
                    (response?.message || 'No se pudo eliminar la carpeta')
            )
            return
        }

        hide_material_folder_form()
        await load_materials()
    } catch (error) {
        console.error('Error deleting material folder:', error)
        alert(
            'error: ' +
                materialsErrorMessage(
                    error,
                    'Error de conexión al eliminar la carpeta'
                )
        )
    }
}

async function delete_material_file_prompt(file) {
    const res = window.prompt("Teclea 'eliminar' para confirmar")
    if (res !== 'eliminar') {
        alert('Eliminación cancelada')
        return
    }

    try {
        const response = await deleteMaterial(file.id)

        if (!response || !response.status) {
            alert(
                'error: ' +
                    (response?.message || 'No se pudo eliminar el archivo')
            )
            return
        }

        await load_materials()
    } catch (error) {
        console.error('Error deleting material file:', error)
        alert(
            'error: ' +
                materialsErrorMessage(
                    error,
                    'Error de conexión al eliminar el archivo'
                )
        )
    }
}

// Extrae, de una selección de carpeta local (input webkitdirectory), todas
// las rutas de carpeta (no de archivo) en cada nivel de profundidad.
function extractFolderPathsFromFiles(files) {
    const folderPaths = new Set()

    files.forEach((file) => {
        const relativePath = file.webkitRelativePath || file.name
        const segments = relativePath.split('/')
        segments.pop() // quitar el nombre del archivo

        let current = ''
        segments.forEach((segment) => {
            current = current === '' ? segment : `${current}/${segment}`
            folderPaths.add(current)
        })
    })

    return Array.from(folderPaths)
}

function materialFileFolderPath(file) {
    const relativePath = file.webkitRelativePath || file.name
    const segments = relativePath.split('/')
    segments.pop()
    return segments.join('/')
}

async function upload_materials_to_folder(folderId, files) {
    try {
        const response = await uploadMaterials(folderId, files)
        if (!response || !response.status) {
            throw new Error(
                response?.message || 'No se pudieron subir los archivos'
            )
        }

        return {
            uploadedCount: Array.isArray(response.data) ? response.data.length : 0,
        }
    } catch (error) {
        // Reemplazamos el mensaje genérico del backend (con índices como
        // "files.6") por uno que identifica el archivo real, para que el
        // usuario pueda encontrarlo y corregirlo o quitarlo.
        const detailedMessage = describeMaterialsUploadError(error, files)
        if (detailedMessage) error.message = detailedMessage
        throw error
    }
}

async function upload_material_cover_to_folder(folderId, file) {
    const response = await uploadFolderCover(folderId, file)
    if (!response || !response.status) {
        throw new Error(response?.message || 'No se pudo subir la portada')
    }
}

function update_material_cover_preview(src) {
    const preview = document.getElementById('mf_cover_preview')
    if (!preview) {
        return
    }

    if (materialsCoverPreviewObjectUrl) {
        URL.revokeObjectURL(materialsCoverPreviewObjectUrl)
        materialsCoverPreviewObjectUrl = null
    }

    if (!src) {
        preview.classList.add('hide')
        preview.style.backgroundImage = ''
        return
    }

    preview.style.backgroundImage = `url("${src}")`
    preview.classList.remove('hide')
}

function wireMaterialsUI() {
    document
        .getElementById('btn_new_root_folder')
        ?.addEventListener('click', (e) => {
            e.preventDefault()
            show_material_folder_form(null, null)
        })

    document
        .getElementById('btn_upload_tree_root')
        ?.addEventListener('click', (e) => {
            e.preventDefault()
            materialsTreeUploadParentId = null
            document.getElementById('input_upload_tree').click()
        })

    document
        .getElementById('btn_save_material_folder')
        ?.addEventListener('click', save_material_folder)

    document
        .getElementById('btn_cancel_material_folder')
        ?.addEventListener('click', (e) => {
            e.preventDefault()
            hide_material_folder_form()
        })

    document
        .getElementById('btn_delete_material_folder')
        ?.addEventListener('click', (e) => {
            e.preventDefault()
            const id = document.getElementById('mf_id').value
            if (!id) return
            delete_material_folder_prompt({ id })
        })

    document
        .getElementById('mf_cover')
        ?.addEventListener('change', function () {
            const file = this.files?.[0]
            if (!file) {
                return
            }

            const tempUrl = URL.createObjectURL(file)
            materialsCoverPreviewObjectUrl = tempUrl
            update_material_cover_preview(tempUrl)
        })

    document
        .getElementById('input_upload_materials')
        ?.addEventListener('change', async function () {
            const files = Array.from(this.files)
            if (files.length === 0 || !materialsUploadTargetFolderId) return

            try {
                const uploadResult = await upload_materials_to_folder(
                    materialsUploadTargetFolderId,
                    files
                )
                await load_materials()
                alert(
                    `Carga finalizada correctamente. Se subieron ${uploadResult.uploadedCount} archivo(s).`
                )
            } catch (error) {
                console.error('Error uploading materials:', error)
                alert(
                    'error: ' +
                        materialsErrorMessage(
                            error,
                            'Error de conexión al subir archivos'
                        )
                )
            } finally {
                this.value = ''
                materialsUploadTargetFolderId = null
            }
        })

    document
        .getElementById('input_upload_tree')
        ?.addEventListener('change', async function () {
            const files = Array.from(this.files)
            if (files.length === 0) return

            const parentId = materialsTreeUploadParentId
            this.closest('.filter_row')
                ?.querySelector('#btn_upload_tree_root')
                ?.classList.add('loading')

            try {
                const folderPaths = extractFolderPathsFromFiles(files)
                const treeResponse = await createFolderTree(
                    parentId,
                    folderPaths
                )

                if (!treeResponse || !treeResponse.status) {
                    alert(
                        'error: ' +
                            (treeResponse?.message ||
                                'No se pudo crear el árbol de carpetas')
                    )
                    return
                }

                const folderIds = treeResponse.data.folderIds

                // Agrupar archivos por carpeta destino
                const filesByFolder = new Map()
                files.forEach((file) => {
                    const path = materialFileFolderPath(file)
                    const folderId = path === '' ? parentId : folderIds[path]
                    if (!folderId) return
                    if (!filesByFolder.has(folderId))
                        filesByFolder.set(folderId, [])
                    filesByFolder.get(folderId).push(file)
                })

                // Subir en lotes de máximo 10 archivos por carpeta
                let uploadedCount = 0
                for (const [folderId, folderFiles] of filesByFolder) {
                    for (let i = 0; i < folderFiles.length; i += 10) {
                        const uploadResult = await upload_materials_to_folder(
                            folderId,
                            folderFiles.slice(i, i + 10)
                        )
                        uploadedCount += uploadResult.uploadedCount
                    }
                }

                await load_materials()
                alert(
                    `Carga finalizada correctamente. Se subieron ${uploadedCount} archivo(s).`
                )
            } catch (error) {
                console.error('Error uploading material tree:', error)
                alert(
                    'error: ' +
                        materialsErrorMessage(
                            error,
                            'Error de conexión al subir el árbol de carpetas'
                        )
                )
            } finally {
                this.value = ''
                materialsTreeUploadParentId = null
                this.closest('.filter_row')
                    ?.querySelector('#btn_upload_tree_root')
                    ?.classList.remove('loading')
            }
        })
}

document.addEventListener('DOMContentLoaded', wireMaterialsUI, false)

async function load() {
  try {
    // Verificar autenticación primero
    if (!checkAuth()) {
      return;
    }

    show_lng(page_lng);
    document.querySelector(".admin_version").innerHTML = version;

    empty_all_fields();

    // Cargar configuración en segundo plano
    load_config().catch((err) => console.error("Error loading config:", err));

    document.querySelectorAll("[aria-action]").forEach((el) => {
      el.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          functions[el.getAttribute("href")](el);
        },
        false,
      );
    });

    // --- Importación Excel de probióticos (US-04 Etapa 02) ---
    const inputImportProbiotics = document.getElementById("input_import_probiotics");
    if (inputImportProbiotics) {
      document.getElementById("btn_import_probiotics").addEventListener("click", (e) => {
        e.preventDefault();
        inputImportProbiotics.click();
      });

      inputImportProbiotics.addEventListener("change", async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!confirm(
          `¿Importar "${file.name}"?\n\n` +
          `El archivo se tratará como la matriz completa.\n` +
          `Los probióticos de origen matriz que no aparezcan se darán de baja.\n` +
          `Los registros manuales o de farmacia ausentes no se modificarán.\n` +
          `Si hay errores en filas, se procesarán los válidos pero no se aplicarán bajas.`
        )) {
          e.target.value = "";
          return;
        }

        const btn = document.getElementById("btn_import_probiotics");
        btn.classList.add("loading");

        try {
          const formData = new FormData();
          formData.append("file", file);
          const resp = await importProbiotics(formData);
          const d = resp.data ?? resp;

          const errors = d.errors ?? [];
          document.getElementById("import_result_new").textContent = d.imported ?? 0;
          document.getElementById("import_result_updated").textContent = d.updated ?? 0;
          document.getElementById("import_result_restored").textContent = d.restored ?? 0;
          document.getElementById("import_result_deactivated").textContent = d.deactivated ?? 0;
          document.getElementById("import_result_links_created").textContent = d.links_created ?? 0;
          document.getElementById("import_result_masters_deactivated").textContent = d.masters_deactivated ?? 0;
          document.getElementById("import_result_error_count").textContent = errors.length;

          const syncNotice = document.getElementById("import_result_sync_notice");
          if (syncNotice) {
            syncNotice.classList.remove("hide", "success", "warning");
            if (d.full_sync_applied) {
              syncNotice.classList.add("success");
              syncNotice.textContent =
                "Sincronización total aplicada. Los probióticos de origen matriz ausentes fueron dados de baja.";
            } else if (errors.length) {
              syncNotice.classList.add("warning");
              syncNotice.textContent =
                "Sincronización parcial: hubo errores y no se aplicaron bajas por ausencia. Corrija el archivo e importe de nuevo.";
            } else {
              syncNotice.classList.add("hide");
              syncNotice.textContent = "";
            }
          }

          const errorsBlock = document.getElementById("import_result_errors_block");
          const errorsList  = document.getElementById("import_result_errors_list");
          errorsList.innerHTML = "";
          if (errors.length) {
            errorsBlock.classList.remove("hide");
            errors.forEach((msg) => {
              const row = document.createElement("div");
              row.className = "import_error_row";
              row.textContent = msg;
              errorsList.appendChild(row);
            });
          } else {
            errorsBlock.classList.add("hide");
          }

          change_section("section", "section_import_result", true);
        } catch (error) {
          console.error("Import probiotics error:", error);
          alert("Error al importar. Verifica el formato del archivo.");
        } finally {
          btn.classList.remove("loading");
          e.target.value = ""; // Limpiar para permitir reimportar el mismo archivo
        }
      });
    }

    // --- Importación Excel probióticos de farmacia (US-10 Etapa 05) ---
    const inputPharmProbFile = document.getElementById("input_pharm_probiotics_file");
    if (inputPharmProbFile) {
      document.getElementById("btn_import_pharm_probiotics").addEventListener("click", () => {
        inputPharmProbFile.click();
      });

      inputPharmProbFile.addEventListener("change", async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const pharmId = document.getElementById("pharm_id")?.value;
        if (!pharmId) {
          alert("No se encontró la farmacia activa.");
          e.target.value = "";
          return;
        }

        if (!confirm(`¿Importar "${file.name}" para esta farmacia?\nSe crearán o actualizarán sus probióticos.\n\nColumnas esperadas: CN, Nombre y PVP.\nSi un CN no está en la guía, se busca el producto por nombre: las coincidencias probables se listarán para que las aceptes o las rechaces.\nSi un CN no está en la guía y la fila no trae nombre, esa fila se omitirá.`)) {
          e.target.value = "";
          return;
        }

        await import_pharm_probiotics(pharmId, file);
        e.target.value = "";
      });
    }

    const today = new Date().toISOString().split("T")[0];
    if (document.getElementById("filter_report_from"))
      document.getElementById("filter_report_from").value = today;
    if (document.getElementById("filter_report_to"))
      document.getElementById("filter_report_to").value = today;
    if (document.getElementById("filter_services_from"))
      document.getElementById("filter_services_from").value = today;
    if (document.getElementById("filter_services_to"))
      document.getElementById("filter_services_to").value = today;

    // Inicializar fechas de agenda
    if (document.getElementById("filter_dates_from")) {
      const firstDay = new Date(new Date().getFullYear(), 0, 1)
        .toISOString()
        .split("T")[0];
      document.getElementById("filter_dates_from").value = firstDay;
    }
    if (document.getElementById("filter_dates_to")) {
      document.getElementById("filter_dates_to").value = today;
    }

    document.querySelectorAll(".btn_update_fields").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          update_fields_data(this);
        },
        false,
      );
    });

    document.querySelectorAll(".btn_new_fields").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          empty_fields(
            this.getAttribute("aria-parent"),
            this.getAttribute("aria-class"),
          );
        },
        false,
      );
    });

    // Actualizar opciones de ps_type al cambiar ps_service (Etapa 04 — Probiomentor)
    const psServiceEl = document.getElementById("ps_service");
    if (psServiceEl) {
      psServiceEl.addEventListener("change", function () {
        update_ps_type_options(this.value);
      });
    }

    document.querySelectorAll(".btn_remove_item").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          const res = window.prompt("Teclea 'eliminar' para confirmar");
          if (res == "eliminar")
            remove_item(
              this,
              this.getAttribute("aria-parent"),
              this.getAttribute("aria-table"),
              this.getAttribute("aria-field"),
              this.getAttribute("aria-class"),
            );
          else alert("Eliminación cancelada");
        },
        false,
      );
    });

    document
      .getElementById("btn_new_pharm")
      .addEventListener("click", function (e) {
        e.preventDefault();
        change_section("section", "section_pharm_data", true);
        document.getElementById("table_pharms").setAttribute("current_row", "");
        document.getElementById("table_pharms").setAttribute("current_id", 0);

        document.getElementById("filter_pharm_name").innerText = "Nueva";

        empty_fields(
          this.getAttribute("aria-parent"),
          this.getAttribute("aria-class"),
        );
        empty_fields("tab_pharm_services", "ps_field");
        empty_fields("tab_pharm_staff", "staff_field");
        empty_fields("tab_pharm_actions", "action_field");
        empty_fields("tab_pharm_ergo", "ergo_field");
        clear_pharm_related_tables();

        document.getElementById("btn_delete_pharm").classList.add("hide");

        document
          .querySelector(".tab_link.selected")
          .classList.remove("selected");
        document
          .querySelector('.tab_link[aria-tab="tab_pharm_data"]')
          .classList.add("selected");
        change_section(".tab_pharm", this.getAttribute("aria-tab"));

        document
          .getElementById("btn_update_pharm")
          .querySelector(".text_update")
          .classList.add("hide");
        document
          .getElementById("btn_update_pharm")
          .querySelector(".text_add")
          .classList.remove("hide");
      });

    document.querySelectorAll(".nav_link").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          document
            .querySelector(".nav_link.selected")
            .classList.remove("selected");
          element.classList.add("selected");
          change_section("section", element.getAttribute("aria-section"));
        },
        false,
      );
    });
    document.querySelectorAll(".tab_link").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          document
            .querySelector(".tab_link.selected")
            .classList.remove("selected");
          element.classList.add("selected");
          change_section(".tab_pharm", element.getAttribute("aria-tab"));
        },
        false,
      );
    });
    document.querySelectorAll(".drug_tab_link").forEach((element) => {
      element.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          setActiveDrugTab(element.getAttribute("aria-tab"));
        },
        false,
      );
    });

    document
      .getElementById("btn_filter_pharms")
      .addEventListener("click", load_pharms);

    // Cargar farmacias inicialmente
    load_pharms(null);

    // Event listeners para probióticos
    document
      .getElementById("btn_filter_probiotics")
      .addEventListener("click", load_probiotics);

    document
      .getElementById("btn_clear_probiotics")
      .addEventListener("click", function (e) {
        e.preventDefault();
        document.getElementById("filter_prob_name").value = "";
        document.getElementById("filter_prob_cn").value = "";
        document.getElementById("filter_prob_lab_id").value = "";
        document.getElementById("filter_prob_presentation_id").value = "";
        document.getElementById("filter_prob_evaluable").value = "";
        document.getElementById("filter_prob_review_from").value = "";
        document.getElementById("filter_prob_review_to").value = "";
        document.getElementById("filter_probiotics_active").value = "1";
        document.getElementById("filter_probiotics_sort").value = "prob_name";
        load_probiotics();
      });

    document
      .getElementById("btn_new_probiotic")
      .addEventListener("click", function (e) {
        e.preventDefault();
        showNewProbioticForm();
      });

    document
      .getElementById("btn_return_probiotics")
      .addEventListener("click", function (e) {
        e.preventDefault();
        empty_fields("tab_probiotic_data", "probiotic_field");
        empty_fields("tab_probiotic_indications", "probiotic_indication_field");
        setActiveProbioticTab("tab_probiotic_data");
        change_section("section", "section_probiotics", true);
      });

    document
      .getElementById("btn_return_import_result")
      .addEventListener("click", function (e) {
        e.preventDefault();
        change_section("section", "section_probiotics", true);
      });

    document
      .getElementById("btn_download_import_errors")
      .addEventListener("click", function (e) {
        e.preventDefault();
        const rows = document.querySelectorAll("#import_result_errors_list .import_error_row");
        if (!rows.length) return;
        const text = Array.from(rows).map((r) => r.textContent).join("\n");
        const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement("a");
        a.href     = url;
        a.download = `errores_import_probioticos_${new Date().toISOString().slice(0, 10)}.txt`;
        a.click();
        URL.revokeObjectURL(url);
      });

    document
      .getElementById("btn_close_probiotic")
      .addEventListener("click", function (e) {
        e.preventDefault();
        empty_fields("tab_probiotic_data", "probiotic_field");
        empty_fields("tab_probiotic_indications", "probiotic_indication_field");
        setActiveProbioticTab("tab_probiotic_data");
        change_section("section", "section_probiotics", true);
      });

    document
      .getElementById("btn_delete_probiotic")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const probId = document
          .getElementById("table_probiotics")
          .getAttribute("current_id");
        const probName = document.getElementById("prob_name").value;

        if (confirm(`¿Estás seguro de que deseas eliminar el probiótico "${probName}"?`)) {
          try {
            const json = await deleteProbiotic(probId);
            if (json && json.status) {
              alert("Probiótico eliminado correctamente");
              empty_fields("tab_probiotic_data", "probiotic_field");
              change_section("section", "section_probiotics", true);
              load_probiotics();
            } else {
              alert("Error al eliminar: " + (json?.message || "Error desconocido"));
            }
          } catch (error) {
            console.error("Error deleting probiotic:", error);
            alert("Error de conexión al eliminar el probiótico");
          }
        }
      });

    document
      .getElementById("prob_evaluable")
      .addEventListener("change", function () {
        toggleExclusionReason(parseInt(this.value));
        toggleIndicationFormByEvaluable(parseInt(this.value));
      });

    document.querySelectorAll(".probiomentor_tab_link").forEach((element) => {
      element.addEventListener("click", function (e) {
        e.preventDefault();
        const tabId = element.getAttribute("aria-tab");
        setActiveProbiomentorTab(tabId);
        if (tabId === "tab_probiomentor_probiotics") {
          load_probiotics();
          load_lab_dropdown();
          load_format_dropdown();
        } else if (tabId === "tab_probiomentor_pending") {
          load_reported_probiotics();
        } else if (tabId === "tab_probiomentor_labs") {
          load_laboratories();
        } else if (tabId === "tab_probiomentor_presentations") {
          load_presentations();
        } else if (tabId === "tab_probiomentor_doses") {
          load_doses();
        } else if (tabId === "tab_probiomentor_indications") {
          load_master_indications();
        } else if (tabId === "tab_probiomentor_consultas") {
          load_consultas();
        }
      }, false);
    });

    document.querySelectorAll(".probiotic_tab_link").forEach((element) => {
      element.addEventListener("click", function (e) {
        e.preventDefault();
        const tabId = element.getAttribute("aria-tab");
        setActiveProbioticTab(tabId);
        if (tabId === "tab_probiotic_indications") {
          const probId = document
            .getElementById("table_probiotics")
            .getAttribute("current_id");
          load_dose_dropdown();
          if (Number(probId) > 0) {
            load_probiotic_indications(probId);
          }
        } else if (tabId === "tab_probiotic_reviews") {
          const probId = document
            .getElementById("table_probiotics")
            .getAttribute("current_id");
          if (Number(probId) > 0) {
            load_probiotic_reviews(probId);
          }
        }
      }, false);
    });

    document
      .getElementById("btn_save_probiotic_indication")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const btn = e.currentTarget;
        if (btn.classList.contains("disabled")) return;

        const probId = document
          .getElementById("table_probiotics")
          .getAttribute("current_id");
        if (!(Number(probId) > 0)) {
          alert("Guarda primero los datos del probiótico");
          return;
        }

        const probEvaluable = document.getElementById("prob_evaluable")?.value;
        if (probEvaluable === "0") {
          alert("Este probiótico es no evaluable (sin evidencia científica). No se pueden crear indicaciones.");
          return;
        }

        const indicationIdVal = document.getElementById("pil_indication_id").value;

        if (!indicationIdVal || indicationIdVal === '__new__') {
          alert("Selecciona una indicación maestra antes de guardar");
          return;
        }

        const payload = {
          pil_indication_id: parseInt(indicationIdVal, 10),
          pil_evidence:      document.getElementById("pil_evidence").value || null,
          pil_dose_id:       document.getElementById("pil_dose_id").value || null,
          pil_pauta:         document.getElementById("pil_pauta").value || null,
          pil_population:    document.getElementById("pil_population").value || null,
          pil_notes:         document.getElementById("pil_notes").value || null,
        };

        const visibleSpan = btn.querySelector('.btn_text:not(.hide)');
        const originalText = visibleSpan?.textContent;
        btn.classList.add("disabled");
        if (visibleSpan) visibleSpan.textContent = "Guardando…";

        try {
          const linkId = document
            .getElementById("tab_probiotic_indications")
            .getAttribute("current_link_id");
          let json;

          if (linkId) {
            json = await updateProbioticIndication(probId, linkId, payload);
          } else {
            json = await addProbioticIndication(probId, payload);
          }

          if (!json || !json.status) {
            alert("Error al guardar indicación: " + (json?.message || "Error desconocido"));
            return;
          }

          // Reset form
          empty_fields("tab_probiotic_indications", "probiotic_indication_field");
          document.getElementById("new_master_indication_block").classList.add("hide");
          document.getElementById("btn_remove_probiotic_indication").classList.add("hide");
          document.getElementById("btn_save_probiotic_indication").querySelector(".text_add").classList.remove("hide");
          document.getElementById("btn_save_probiotic_indication").querySelector(".text_update").classList.add("hide");
          document.getElementById("tab_probiotic_indications").removeAttribute("current_link_id");

          await load_probiotic_indications(probId);
        } catch (error) {
          console.error("Error saving indication:", error);
          alert("Error de conexión al guardar indicación");
        } finally {
          btn.classList.remove("disabled");
          if (visibleSpan && originalText) visibleSpan.textContent = originalText;
        }
      });

    document
      .getElementById("btn_remove_probiotic_indication")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const probId = document
          .getElementById("table_probiotics")
          .getAttribute("current_id");
        const linkId = document
          .getElementById("tab_probiotic_indications")
          .getAttribute("current_link_id");

        if (!linkId) return;

        if (confirm("¿Eliminar esta indicación del probiótico?")) {
          try {
            const json = await removeProbioticIndication(probId, linkId);
            if (json && json.status) {
              empty_fields("tab_probiotic_indications", "probiotic_indication_field");
              document.getElementById("new_master_indication_block").classList.add("hide");
              document.getElementById("btn_remove_probiotic_indication").classList.add("hide");
              document.getElementById("btn_save_probiotic_indication").querySelector(".text_add").classList.remove("hide");
              document.getElementById("btn_save_probiotic_indication").querySelector(".text_update").classList.add("hide");
              document.getElementById("tab_probiotic_indications").removeAttribute("current_link_id");
              await load_probiotic_indications(probId);
            } else {
              alert("Error al eliminar: " + (json?.message || "Error desconocido"));
            }
          } catch (error) {
            console.error("Error removing indication:", error);
            alert("Error de conexión al eliminar indicación");
          }
        }
      });

    // ── Indicación maestra: mostrar/ocultar bloque de alta en línea ────────────
    document
      .getElementById("pil_indication_id")
      .addEventListener("change", function () {
        const block = document.getElementById("new_master_indication_block");
        if (this.value === "__new__") {
          block.classList.remove("hide");
          document.getElementById("pmi_name_es").focus();
        } else {
          block.classList.add("hide");
        }
      });

    // ── Crear nueva indicación maestra al vuelo ─────────────────────────────
    document
      .getElementById("btn_create_master_indication")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const btn = e.currentTarget;
        if (btn.classList.contains("disabled")) return;

        const nameEs = document.getElementById("pmi_name_es").value.trim();
        const nameCa = document.getElementById("pmi_name_ca").value.trim() || null;

        if (!nameEs) {
          alert("Escribe el nombre de la indicación en español");
          return;
        }

        const originalText = btn.textContent;
        btn.classList.add("disabled");
        btn.textContent = "Creando…";

        try {
          const json = await createProbioticMasterIndication({ pmi_name_es: nameEs, pmi_name_ca: nameCa });

          if (!json || !json.status) {
            alert("Error al crear indicación maestra: " + (json?.message || "Error desconocido"));
            return;
          }

          const newId = json.data.pmi_id;

          // Recargar dropdown y seleccionar la recién creada
          await load_master_indications_dropdown(newId);

          // Ocultar bloque y limpiar inputs
          document.getElementById("new_master_indication_block").classList.add("hide");
          document.getElementById("pmi_name_es").value = "";
          document.getElementById("pmi_name_ca").value = "";
        } catch (error) {
          console.error("Error creating master indication:", error);
          alert("Error de conexión al crear indicación maestra");
        } finally {
          btn.classList.remove("disabled");
          btn.textContent = originalText;
        }
      });

    // ── Revisiones del probiótico ───────────────────────────────────────────────
    document
      .getElementById('btn_save_probiotic_review')
      ?.addEventListener('click', async function (e) {
        e.preventDefault();

        const probId = document
          .getElementById('table_probiotics')
          .getAttribute('current_id');

        if (!probId || Number(probId) === 0) {
          alert('Guarda primero los datos del probiótico antes de registrar una revisión');
          return;
        }

        const reviewDate = document.getElementById('pr_review_date')?.value;
        if (!reviewDate) {
          alert('Selecciona la fecha de revisión');
          return;
        }

        const payload = {
          pr_review_date: reviewDate,
          pr_note:        document.getElementById('pr_note')?.value || null,
        };

        try {
          const json = await addProbioticReview(probId, payload);

          if (!json || !json.status) {
            alert('Error al registrar revisión: ' + (json?.message || 'Error desconocido'));
            return;
          }

          // Resetear formulario: nota vacía, fecha = hoy
          if (document.getElementById('pr_note')) document.getElementById('pr_note').value = '';
          if (document.getElementById('pr_review_date')) {
            document.getElementById('pr_review_date').value = new Date().toISOString().split('T')[0];
          }

          // Refrescar historial y columna de la lista maestra
          await load_probiotic_reviews(probId);
          load_probiotics();
        } catch (error) {
          console.error('Error saving review:', error);
          alert('Error de conexión al registrar revisión');
        }
      });

    // ── Labs ────────────────────────────────────────────────────────────────────
    document.getElementById('btn_filter_labs')?.addEventListener('click', (e) => {
      e.preventDefault();
      load_laboratories();
    });

    document.getElementById('btn_clear_labs')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('filter_lab_name').value = '';
      load_laboratories();
    });

    document.getElementById('btn_new_lab')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_lab_form(null, null);
    });

    document.getElementById('btn_cancel_lab')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_lab_form(null, null);
    });

    document.getElementById('btn_save_lab')?.addEventListener('click', async (e) => {
      e.preventDefault();
      const form  = document.getElementById('lab_form');
      const labId = parseInt(form.getAttribute('current_id') || 0);
      const data  = {
        lab_name: document.getElementById('lab_name').value.trim(),
      };

      if (!data.lab_name) { alert('El nombre del laboratorio es obligatorio'); return; }

      try {
        const json = labId > 0
          ? await updateLaboratory(labId, data)
          : await createLaboratory(data);

        if (!json || !json.status) {
          alert('Error al guardar: ' + (json?.message || 'Error desconocido'));
          return;
        }

        await load_laboratories();
        show_lab_form(null, null);
        alert('Laboratorio guardado correctamente');
      } catch (error) {
        alert('Error de conexión al guardar laboratorio');
      }
    });

    document.getElementById('btn_delete_lab')?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!confirm('¿Confirmar eliminación del laboratorio?')) return;

      const labId = parseInt(document.getElementById('lab_form').getAttribute('current_id') || 0);
      if (!labId) return;

      try {
        const json = await deleteLaboratory(labId);
        if (!json || !json.status) {
          alert('Error al eliminar: ' + (json?.message || 'Error desconocido'));
          return;
        }
        await load_laboratories();
        show_lab_form(null, null);
      } catch (error) {
        alert('Error de conexión al eliminar laboratorio');
      }
    });

    // ── Presentaciones ────────────────────────────────────────────────────────
    document.getElementById('btn_filter_presentations')?.addEventListener('click', (e) => {
      e.preventDefault();
      load_presentations();
    });

    document.getElementById('btn_filter_consultas')?.addEventListener('click', load_consultas);

    document.getElementById('btn_clear_presentations')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('filter_pp_name').value = '';
      load_presentations();
    });

    document.getElementById('btn_new_presentation')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_presentation_form(null, null);
    });

    document.getElementById('btn_cancel_presentation')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_presentation_form(null, null);
    });

    document.getElementById('btn_save_presentation')?.addEventListener('click', async (e) => {
      e.preventDefault();
      const form           = document.getElementById('presentation_form');
      const presentationId = parseInt(form.getAttribute('current_id') || 0);
      const data           = {
        pp_name: document.getElementById('pp_name').value.trim(),
      };

      if (!data.pp_name) { alert('El nombre de la presentación es obligatorio'); return; }

      try {
        const json = presentationId > 0
          ? await updateProbioticPresentation(presentationId, data)
          : await createProbioticPresentation(data);

        if (!json || !json.status) {
          alert('Error al guardar: ' + (json?.message || 'Error desconocido'));
          return;
        }

        await load_presentations();
        show_presentation_form(null, null);
        alert('Presentación guardada correctamente');
      } catch (error) {
        alert('Error de conexión al guardar presentación');
      }
    });

    document.getElementById('btn_delete_presentation')?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!confirm('¿Confirmar eliminación de la presentación?')) return;

      const presentationId = parseInt(document.getElementById('presentation_form').getAttribute('current_id') || 0);
      if (!presentationId) return;

      try {
        const json = await deleteProbioticPresentation(presentationId);
        if (!json || !json.status) {
          alert('Error al eliminar: ' + (json?.message || 'Error desconocido'));
          return;
        }
        await load_presentations();
        show_presentation_form(null, null);
      } catch (error) {
        alert('Error de conexión al eliminar presentación');
      }
    });

    // ── Dosis ─────────────────────────────────────────────────────────────────
    document.getElementById('btn_filter_doses')?.addEventListener('click', (e) => {
      e.preventDefault();
      load_doses();
    });

    document.getElementById('btn_clear_doses')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('filter_pd_name').value = '';
      load_doses();
    });

    document.getElementById('btn_new_dose')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_dose_form(null, null);
    });

    document.getElementById('btn_cancel_dose')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_dose_form(null, null);
    });

    document.getElementById('btn_save_dose')?.addEventListener('click', async (e) => {
      e.preventDefault();
      const form   = document.getElementById('dose_form');
      const doseId = parseInt(form.getAttribute('current_id') || 0);
      const data   = {
        pd_name: document.getElementById('pd_name').value.trim(),
      };

      if (!data.pd_name) { alert('La dosis es obligatoria'); return; }

      try {
        const json = doseId > 0
          ? await updateProbioticDose(doseId, data)
          : await createProbioticDose(data);

        if (!json || !json.status) {
          alert('Error al guardar: ' + (json?.message || 'Error desconocido'));
          return;
        }

        await load_doses();
        await load_dose_dropdown();
        show_dose_form(null, null);
        alert(json.restored
          ? 'La dosis ya existía dada de baja y se ha restaurado'
          : 'Dosis guardada correctamente');
      } catch (error) {
        // El backend responde 422 cuando la dosis duplica una existente.
        alert(error?.message || 'Error de conexión al guardar la dosis');
      }
    });

    document.getElementById('btn_delete_dose')?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!confirm('¿Confirmar eliminación de la dosis?')) return;

      const doseId = parseInt(document.getElementById('dose_form').getAttribute('current_id') || 0);
      if (!doseId) return;

      try {
        const json = await deleteProbioticDose(doseId);
        if (!json || !json.status) {
          alert('Error al eliminar: ' + (json?.message || 'Error desconocido'));
          return;
        }
        await load_doses();
        await load_dose_dropdown();
        show_dose_form(null, null);
      } catch (error) {
        // 422 cuando la dosis está en uso por indicaciones activas.
        alert(error?.message || 'Error de conexión al eliminar la dosis');
      }
    });

    // ── Indicaciones maestras ─────────────────────────────────────────────────
    document.getElementById('btn_filter_master_indications')?.addEventListener('click', (e) => {
      e.preventDefault();
      load_master_indications();
    });

    document.getElementById('btn_clear_master_indications')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('filter_pmi_name').value = '';
      load_master_indications();
    });

    document.getElementById('btn_new_master_indication_tab')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_master_indication_form(null, null);
    });

    document.getElementById('btn_cancel_master_indication')?.addEventListener('click', (e) => {
      e.preventDefault();
      show_master_indication_form(null, null);
    });

    document.getElementById('pmi_keyword_input')?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ',') {
        e.preventDefault();
        addMasterIndicationKeyword(e.target.value);
        e.target.value = '';
      }
    });

    document.getElementById('pmi_keyword_input')?.addEventListener('blur', (e) => {
      if (!e.target.value.trim()) return;
      addMasterIndicationKeyword(e.target.value);
      e.target.value = '';
    });

    document.getElementById('btn_save_master_indication')?.addEventListener('click', async (e) => {
      e.preventDefault();
      const form = document.getElementById('master_indication_form');
      const indicationId = parseInt(form.getAttribute('current_id') || 0, 10);
      const data = {
        pmi_name_es: document.getElementById('catalog_pmi_name_es').value.trim(),
        pmi_name_ca: document.getElementById('catalog_pmi_name_ca').value.trim() || null,
        keywords: [...masterIndicationKeywordDraft],
      };

      if (!data.pmi_name_es) {
        alert('El nombre en español es obligatorio');
        return;
      }

      try {
        const json = indicationId > 0
          ? await updateProbioticMasterIndication(indicationId, data)
          : await createProbioticMasterIndication(data);

        if (!json || !json.status) {
          alert('Error al guardar: ' + (json?.message || 'Error desconocido'));
          return;
        }

        await load_master_indications();
        await load_master_indications_dropdown();
        show_master_indication_form(null, null);
        alert('Indicación guardada correctamente');
      } catch (error) {
        alert(error?.message || 'Error de conexión al guardar la indicación');
      }
    });

    // Event listeners para medicamentos
    document
      .getElementById("btn_filter_drugs")
      .addEventListener("click", load_drugs);

    document
      .getElementById("btn_filter_dates")
      .addEventListener("click", load_appointments);

    document
      .getElementById("btn_clear_dates")
      .addEventListener("click", function (e) {
        e.preventDefault();
        // Limpiar filtros
        document.getElementById("filter_dates_pharm").value = "0";
        document.getElementById("filter_dates_service").value = "0";

        const today = new Date().toISOString().split("T")[0];
        const firstDay = new Date(new Date().getFullYear(), 0, 1)
          .toISOString()
          .split("T")[0];

        document.getElementById("filter_dates_from").value = firstDay;
        document.getElementById("filter_dates_to").value = today;

        // Recargar tabla
        load_appointments();
      });

    document
      .getElementById("btn_new_drug")
      .addEventListener("click", function (e) {
        e.preventDefault();
        showNewDrugForm();
      });

    document
      .getElementById("btn_clear_drugs")
      .addEventListener("click", function (e) {
        e.preventDefault();
        // Limpiar filtros
        document.getElementById("filter_drugs_type").value = "drug_name";
        document.getElementById("filter_drugs_value").value = "";
        document.getElementById("filter_drugs_active").value = "1";
        document.getElementById("filter_drugs_sort").value = "drug_name";
        // Recargar tabla
        load_drugs();
      });

    if (document.getElementById("btn_clear_services")) {
      document
        .getElementById("btn_clear_services")
        .addEventListener("click", function (e) {
          e.preventDefault();
          // Limpiar filtros
          document.getElementById("filter_services_type").value = "ALL";
          document.getElementById("filter_services_pharm").value = "";

          const today = new Date().toISOString().split("T")[0];
          document.getElementById("filter_services_from").value = today;
          document.getElementById("filter_services_to").value = today;

          // Recargar tabla
          load_services();
        });
    }

    document
      .getElementById("btn_return_drugs")
      .addEventListener("click", function (e) {
        e.preventDefault();
        empty_fields("tab_drug_data", "drug_field");
        resetDrugDosingRulesState(true);
        setActiveDrugTab("tab_drug_data");
        change_section("section", "section_drugs", true);
      });

    document
      .getElementById("btn_close_drug")
      .addEventListener("click", function (e) {
        e.preventDefault();
        empty_fields("tab_drug_data", "drug_field");
        resetDrugDosingRulesState(true);
        setActiveDrugTab("tab_drug_data");
        change_section("section", "section_drugs", true);
      });

    document
      .getElementById("btn_delete_drug")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const drugId = document
          .getElementById("table_drugs")
          .getAttribute("current_id");
        const drugName = document.getElementById("drug_name").value;

        if (
          confirm(
            `¿Estás seguro de que deseas eliminar el medicamento "${drugName}"?`,
          )
        ) {
          try {
            const json = await deleteDrug(drugId);
            if (json && json.status) {
              alert("Medicamento eliminado correctamente");
              empty_fields("tab_drug_data", "drug_field");
              change_section("section", "section_drugs", true);
            } else {
              alert(
                "Error al eliminar: " + (json?.message || "Error desconocido"),
              );
            }
          } catch (error) {
            console.error("Error deleting drug:", error);
            alert("Error de conexión al eliminar el medicamento");
          }
        }
      });

    document.querySelectorAll("[aria-btn-trigger]").forEach((element) => {
      element.addEventListener(
        "keypress",
        function (e) {
          if (e.key === "Enter") {
            document
              .getElementById(this.getAttribute("aria-btn-trigger"))
              .dispatchEvent(new Event("click"));
          }
        },
        false,
      );
    });
    document.querySelectorAll("[aria-sel-trigger]").forEach((element) => {
      element.addEventListener(
        "change",
        function (e) {
          document
            .getElementById(this.getAttribute("aria-sel-trigger"))
            .dispatchEvent(new Event("click"));
        },
        false,
      );
    });

    document
      .getElementById("btn_delete_pharm")
      .addEventListener("click", async function (e) {
        e.preventDefault();
        const pharmId = document
          .getElementById("table_pharms")
          .getAttribute("current_id");
        const pharmName = document.getElementById("pharm_name").value;

        if (!pharmId || pharmId == 0) {
          alert("Selecciona una farmacia antes de eliminar");
          return;
        }

        const res = window.prompt("Teclea 'eliminar' para confirmar");
        if (res !== "eliminar") {
          alert("Eliminación cancelada");
          return;
        }

        try {
          const json = await deletePharm(pharmId);
          if (json && json.status) {
            alert(`Farmacia "${pharmName}" eliminada correctamente`);
            empty_fields("tab_pharm_data", "pharm_field");
            clear_pharm_related_tables();
            document
              .getElementById("btn_delete_pharm")
              .classList.add("hide");
            document
              .getElementById("table_pharms")
              .setAttribute("current_row", "");
            document
              .getElementById("table_pharms")
              .setAttribute("current_id", 0);
            change_section("section", "section_pharms", true);
            load_pharms();
          } else {
            alert(
              "Error al eliminar: " + (json?.message || "Error desconocido"),
            );
          }
        } catch (error) {
          console.error("Error deleting pharm:", error);
          alert(
            "Error al eliminar la farmacia: " +
              (error?.message || "Error de conexión"),
          );
        }
      });

    document
      .getElementById("btn_return_pharms")
      .addEventListener("click", function (e) {
        e.preventDefault();
        empty_all_fields();
        change_section("section", "section_pharms", true);
      });

    document.querySelectorAll(".btn_pharms_move").forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        empty_all_fields();

        const current = document
          .getElementById("table_pharms")
          .getAttribute("current_row");
        if (!current) return;
        let next = null;
        if (btn.getAttribute("href") == "next")
          next = document.getElementById(current).nextSibling;
        else next = document.getElementById(current).previousSibling;

        if (next) {
          const element = next.getAttribute("aria-id");
          const pharm_name = document.querySelector(
            "#table_pharms [aria-id='" +
              element +
              "'] " +
              "[aria-field='pharm_name']",
          ).innerText;
          document.getElementById("filter_pharm_name").innerText = pharm_name;
          document
            .getElementById("table_pharms")
            .setAttribute("current_row", "pharm_" + element);
          document
            .getElementById("table_pharms")
            .setAttribute("current_id", element);
          load_data(
            { function: "getPharmData", pharm: element },
            "pharm_field",
          );
        }
      });
    });

    document
      .getElementById("btn_view_agreement")
      .addEventListener("click", (e) => {
        e.preventDefault();
        const ag_date = document.getElementById("ag_date").value;
        if (!ag_date) {
          alert("El contrato no está aceptado ni firmado");
          return;
        }
        const popup = document.getElementById("agreement_popup");

        let doc = "agreement_doc";
        if (e.target.hasAttribute("aria-group"))
          doc += "_" + e.target.getAttribute("aria-group");

        popup
          .querySelector("iframe")
          .setAttribute(
            "src",
            document.getElementById(doc).getAttribute("href"),
          );

        popup.classList.remove("hide");
      });

    window.addEventListener("message", async function (e) {
      if (e.data == null) return;

      if (e.data == "farmaval_close_agreement") {
        document.getElementById("agreement_popup").classList.add("hide");
        return;
      }
      if (e.data == "farmaval_agreement_data") {
        const form = "tab_pharm_agreement";

        const ag_date = document.getElementById("ag_date").value;
        const now = new Date(ag_date);
        const data = {
          ag_date_day: now.getDate(),
          ag_date_month_es: document
            .getElementById("agreement_months_es")
            .innerHTML.split(",")[now.getMonth()],
          ag_date_month_ca: document
            .getElementById("agreement_months_ca")
            .innerHTML.split(",")[now.getMonth()],
          ag_date_year: now.getFullYear(),

          ag_date: now.toLocaleDateString("es-ES", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
        };
        document
          .getElementById(form)
          .querySelectorAll(".ag_field")
          .forEach((el) => {
            if (el.tagName === "IMG") {
              data[el.getAttribute("id")] = el.getAttribute("src");
            } else {
              if (el.value && el.value !== "") {
                if (el.tagName === "SELECT")
                  data[el.getAttribute("id")] =
                    el.options[el.selectedIndex].text;
                else data[el.getAttribute("id")] = el.value;
              }
            }
          });

        e.source.postMessage({
          msg: "farmaval_agreement_data",
          data: data,
        });

        return;
      }
    });
  } catch (error) {
    console.error("Error crítico al cargar la aplicación:", error);
    // En caso de error fatal, intentamos limpiar y mostrar el login
    clearSession();
    showLogin();
  }
}

function pharm_added(data) {
  document.getElementById("filter_pharm_name").innerText = data.pharm_name;

  document
    .getElementById("btn_update_pharm")
    .querySelector(".text_add")
    .classList.add("hide");
  document
    .getElementById("btn_update_pharm")
    .querySelector(".text_update")
    .classList.remove("hide");

  document
    .getElementById("table_pharms")
    .setAttribute("current_row", "pharm_" + data.pharm_id);
  document
    .getElementById("table_pharms")
    .setAttribute("current_id", data.pharm_id);
  load_data({ function: "getPharmData", pharm: data.pharm_id }, "pharm_field");
}

function img_to_data(imgElement) {
  const canvas = document.createElement("canvas");
  const contexto = canvas.getContext("2d");

  canvas.width = imgElement.width;
  canvas.height = imgElement.height;

  contexto.drawImage(imgElement, 0, 0);

  const dataURL = canvas.toDataURL("image/png");
  return dataURL;
}

// ── Laboratorios ─────────────────────────────────────────────────────────────

async function load_laboratories() {
  try {
    const filterName = document.getElementById('filter_lab_name')?.value || '';
    const json = await getLaboratories(filterName ? { filter_name: filterName } : {});
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar laboratorios'));
      return;
    }

    const labList = (json.data || []).map((lab) => {
      const lastUpdate =
        lab.lab_updated_at_human ||
        lab.lab_updated_at ||
        lab.updated_at_human ||
        lab.updated_at ||
        lab.last_update ||
        '';

      return {
        ...lab,
        lab_last_update: formatDateTimeForLaboratories(lastUpdate),
      };
    });

    const labCountEl = document.getElementById('filter_labs_count');
    if (labCountEl) labCountEl.innerText = labList.length;

    fill_table('table_laboratories', labList, 'lab', function (labId) {
      show_lab_form(labId, labList.find((lab) => String(lab.lab_id) === String(labId)));
    });
  } catch (error) {
    console.error('Error loading labs:', error);
    alert('Error de conexión al cargar laboratorios');
  }
}

function show_lab_form(labId = null, data = null) {
  const form = document.getElementById('lab_form');
  if (!form) return;

  document.getElementById('lab_name').value = data?.lab_name || '';
  form.setAttribute('current_id', labId || 0);

  const btnDelete = document.getElementById('btn_delete_lab');
  if (labId) {
    btnDelete?.classList.remove('hide');
  } else {
    btnDelete?.classList.add('hide');
  }

  form.classList.remove('hide');
  document.getElementById('lab_name')?.focus();
}

function formatDateForProbiotics(value) {
  if (!value) return '—';
  // Formato ISO yyyy-mm-dd → dd/mm/yyyy
  const parts = String(value).split('T')[0].split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return String(value);
}

function formatDateTimeForLaboratories(value) {
  if (!value) return '—';

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(value);
  }

  const pad = (num) => String(num).padStart(2, '0');
  const day = pad(parsedDate.getDate());
  const month = pad(parsedDate.getMonth() + 1);
  const year = parsedDate.getFullYear();
  const hours = pad(parsedDate.getHours());
  const minutes = pad(parsedDate.getMinutes());
  const seconds = pad(parsedDate.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

async function load_master_indications_dropdown(selectValue = null) {
  try {
    const json = await getProbioticMasterIndications();
    if (!json || !json.status) return;

    const select = document.getElementById('pil_indication_id');
    if (!select) return;

    // Conservar valor actual si no se indica uno explícito
    const currentVal = selectValue !== null ? String(selectValue) : select.value;

    // Reconstruir opciones (siempre placeholder + centinela al principio)
    select.innerHTML = '<option value="">— Selecciona una indicación —</option>' +
                       '<option value="__new__">➕ Crear nueva indicación maestra…</option>';

    json.data.forEach((ind) => {
      const opt       = document.createElement('option');
      opt.value       = ind.pmi_id;
      opt.textContent = ind.pmi_name_es;
      select.appendChild(opt);
    });

    if (currentVal && currentVal !== '__new__') select.value = currentVal;
  } catch (error) {
    console.error('Error loading master indications dropdown:', error);
  }
}

async function load_lab_dropdown() {
  try {
    const json = await getLaboratories();
    if (!json || !json.status) return;

    const targets = [
      { id: 'prob_lab_id',       emptyLabel: '— Sin laboratorio —' },
      { id: 'filter_prob_lab_id', emptyLabel: 'Todos'              },
    ];

    targets.forEach(({ id, emptyLabel }) => {
      const select = document.getElementById(id);
      if (!select) return;
      const currentVal = select.value;
      select.innerHTML = `<option value="">${emptyLabel}</option>`;
      json.data.forEach((lab) => {
        const opt       = document.createElement('option');
        opt.value       = lab.lab_id;
        opt.textContent = lab.lab_name;
        select.appendChild(opt);
      });
      if (currentVal) select.value = currentVal;
    });
  } catch (error) {
    console.error('Error loading lab dropdown:', error);
  }
}

async function load_consultas() {
  const from = document.getElementById('consultas_from')?.value || null;
  const to   = document.getElementById('consultas_to')?.value || null;
  const params = {};
  if (from) params.from = from;
  if (to)   params.to   = to;

  const resp = await getProbiomentorConsultations(params);
  const data = resp?.by_pharmacy || [];
  const total = resp?.total ?? 0;

  document.getElementById('consultas_total_count').textContent = total;
  fill_table('table_consultas', data, 'consultas');
}

async function load_presentations() {
  try {
    const filterName = document.getElementById('filter_pp_name')?.value || '';
    const json = await getProbioticPresentations(filterName ? { filter_name: filterName } : {});
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar presentaciones'));
      return;
    }

    const countEl = document.getElementById('filter_presentations_count');
    if (countEl) countEl.innerText = json.data.length;

    fill_table('table_presentations', json.data, 'presentation', function (presentationId) {
      show_presentation_form(presentationId, json.data.find((p) => String(p.pp_id) === String(presentationId)));
    });
  } catch (error) {
    console.error('Error loading presentations:', error);
    alert('Error de conexión al cargar presentaciones');
  }
}

function show_presentation_form(presentationId = null, data = null) {
  const form = document.getElementById('presentation_form');
  if (!form) return;

  document.getElementById('pp_name').value = data?.pp_name || '';
  form.setAttribute('current_id', presentationId || 0);

  const btnDelete = document.getElementById('btn_delete_presentation');
  if (presentationId) {
    btnDelete?.classList.remove('hide');
  } else {
    btnDelete?.classList.add('hide');
  }

  form.classList.remove('hide');
  document.getElementById('pp_name')?.focus();
}

async function load_format_dropdown() {
  try {
    const json = await getProbioticPresentations();
    if (!json || !json.status) return;

    const targets = [
      { id: 'prob_presentation_id',        emptyLabel: '— Sin presentación —' },
      { id: 'filter_prob_presentation_id', emptyLabel: 'Todas'               },
    ];

    targets.forEach(({ id, emptyLabel }) => {
      const select = document.getElementById(id);
      if (!select) return;
      const currentVal = select.value;
      select.innerHTML = `<option value="">${emptyLabel}</option>`;
      json.data.forEach((p) => {
        const opt       = document.createElement('option');
        opt.value       = p.pp_id;
        opt.textContent = p.pp_name;
        select.appendChild(opt);
      });
      if (currentVal) select.value = currentVal;
    });
  } catch (error) {
    console.error('Error loading format dropdown:', error);
  }
}

async function load_doses() {
  try {
    const filterName = document.getElementById('filter_pd_name')?.value || '';
    const json = await getProbioticDoses(filterName ? { filter_name: filterName } : {});
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar dosis'));
      return;
    }

    const countEl = document.getElementById('filter_doses_count');
    if (countEl) countEl.innerText = json.data.length;

    fill_table('table_doses', json.data, 'dose', function (doseId) {
      show_dose_form(doseId, json.data.find((d) => String(d.pd_id) === String(doseId)));
    });
  } catch (error) {
    console.error('Error loading doses:', error);
    alert('Error de conexión al cargar dosis');
  }
}

function show_dose_form(doseId = null, data = null) {
  const form = document.getElementById('dose_form');
  if (!form) return;

  document.getElementById('pd_name').value = data?.pd_name || '';
  form.setAttribute('current_id', doseId || 0);

  const btnDelete = document.getElementById('btn_delete_dose');
  if (doseId) {
    btnDelete?.classList.remove('hide');
  } else {
    btnDelete?.classList.add('hide');
  }

  form.classList.remove('hide');
  document.getElementById('pd_name')?.focus();
}

let masterIndicationKeywordDraft = [];

function foldMasterIndicationKeyword(text) {
  return (text || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

function addMasterIndicationKeyword(raw) {
  const display = String(raw || '').trim().replace(/\s+/g, ' ');
  if (!display) return;

  display.split(',').forEach((part) => {
    const keyword = part.trim().replace(/\s+/g, ' ');
    if (!keyword) return;
    const folded = foldMasterIndicationKeyword(keyword);
    if (masterIndicationKeywordDraft.some((item) => foldMasterIndicationKeyword(item) === folded)) {
      return;
    }
    masterIndicationKeywordDraft.push(keyword);
  });

  renderMasterIndicationKeywordChips();
}

function renderMasterIndicationKeywordChips() {
  const wrap = document.getElementById('pmi_keywords_chips');
  if (!wrap) return;

  wrap.replaceChildren();
  masterIndicationKeywordDraft.forEach((keyword, index) => {
    const chip = document.createElement('span');
    chip.className = 'keyword_chip';

    const label = document.createElement('span');
    label.textContent = keyword;

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'keyword_chip_remove';
    remove.setAttribute('aria-label', 'Quitar keyword');
    remove.textContent = '×';
    remove.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      masterIndicationKeywordDraft.splice(index, 1);
      renderMasterIndicationKeywordChips();
    });

    chip.append(label, remove);
    wrap.append(chip);
  });
}

async function load_master_indications() {
  try {
    const filterName = document.getElementById('filter_pmi_name')?.value || '';
    const json = await getProbioticMasterIndications(filterName ? { filter_name: filterName } : {});
    if (!json || !json.status) {
      alert('Error: ' + (json?.message || 'Error al cargar indicaciones'));
      return;
    }

    const countEl = document.getElementById('filter_master_indications_count');
    if (countEl) countEl.innerText = json.data.length;

    fill_table('table_master_indications', json.data, 'master_indication', function (indicationId) {
      show_master_indication_form(
        indicationId,
        json.data.find((item) => String(item.pmi_id) === String(indicationId)),
      );
    });
  } catch (error) {
    console.error('Error loading master indications:', error);
    alert('Error de conexión al cargar indicaciones');
  }
}

function show_master_indication_form(indicationId = null, data = null) {
  const form = document.getElementById('master_indication_form');
  if (!form) return;

  document.getElementById('catalog_pmi_name_es').value = data?.pmi_name_es || '';
  document.getElementById('catalog_pmi_name_ca').value = data?.pmi_name_ca || '';
  masterIndicationKeywordDraft = Array.isArray(data?.keywords) ? [...data.keywords] : [];
  renderMasterIndicationKeywordChips();
  document.getElementById('pmi_keyword_input').value = '';

  form.setAttribute('current_id', indicationId || 0);
  form.classList.remove('hide');
  document.getElementById('catalog_pmi_name_es')?.focus();
}

async function load_dose_dropdown() {
  try {
    const json = await getProbioticDoses();
    if (!json || !json.status) return;

    const select = document.getElementById('pil_dose_id');
    if (!select) return;

    const currentVal = select.value;
    select.innerHTML = '<option value="">— Sin dosis —</option>';
    json.data.forEach((d) => {
      const opt       = document.createElement('option');
      opt.value       = d.pd_id;
      opt.textContent = d.pd_name;
      select.appendChild(opt);
    });
    if (currentVal) select.value = currentVal;
  } catch (error) {
    console.error('Error loading dose dropdown:', error);
  }
}

document.addEventListener("DOMContentLoaded", load, false);

const functions = {
  show_services: (el) => {
    load_services();
  },
  export_drugs: async (el) => {
    if (el.classList.contains("loading")) return;
    el.classList.add("loading");

    try {
      const response = await getExportTokenForDrugs();

      if (!response || !response.token) {
        throw new Error("No se pudo obtener el token de exportación");
      }

      const exportUrl = `${farmavel.getBaseUrl()}v1/drugs/export?token=${response.token}`;
      window.open(exportUrl, "_blank");
      el.classList.remove("loading");
    } catch (error) {
      console.error("Export drugs error:", error);
      alert(
        "Error al exportar medicamentos: " +
          (error.message || "No se pudo obtener el permiso de descarga"),
      );
      el.classList.remove("loading");
    }
  },

  export_probiotics: async (el) => {
    if (el.classList.contains("loading")) return;
    el.classList.add("loading");

    try {
      const response = await getExportTokenForProbiotics();

      if (!response || !response.token) {
        throw new Error("No se pudo obtener el token de exportación");
      }

      const exportUrl = `${farmavel.getBaseUrl()}v1/probiotics/export?token=${response.token}`;
      window.open(exportUrl, "_blank");
      el.classList.remove("loading");
    } catch (error) {
      console.error("Export probiotics error:", error);
      alert(
        "Error al exportar la matriz: " +
          (error.message || "No se pudo obtener el permiso de descarga"),
      );
      el.classList.remove("loading");
    }
  },

  export_services: async (el) => {
    if (el.classList.contains("loading")) return;
    el.classList.add("loading");

    const from = document.getElementById("filter_services_from").value;
    const to = document.getElementById("filter_services_to").value;
    const service = document.getElementById("filter_services_type").value;
    const pharmId = document.getElementById("filter_services_pharm").value;

    let params = { from, to, service };
    if (pharmId) params.pharm_id = pharmId;

    try {
      // Paso 1: Solicitar token de acceso para la descarga
      const response = await getExportToken(params);

      if (!response || !response.token) {
        throw new Error("No se pudo obtener el token de exportación");
      }

      // Paso 2: Construir la URL final con el token obtenido
      const exportUrl = `${farmavel.getBaseUrl()}v1/admin/services/export?token=${response.token}`;

      console.log("Export Farmavel (Direct Download with Token):", exportUrl);

      // Abrir en nueva pestaña para iniciar la descarga
      window.open(exportUrl, "_blank");
      el.classList.remove("loading");
    } catch (error) {
      console.error("Export error:", error);
      alert(
        "Error al exportar: " +
          (error.message || "No se pudo obtener el permiso de descarga"),
      );
      el.classList.remove("loading");
    }
  },

  create_reports: async (el) => {
    if (el.classList.contains("loading")) return;
    el.classList.add("loading");

    let params = {
      function: "createReports",
      from: document.getElementById("filter_report_from").value,
      to: document.getElementById("filter_report_to").value,
      service: document.getElementById("filter_report_type").value,
    };
    console.log("Export:", params);
    const json = await fetchWithAuth(server_url, {
      method: "post",
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + getSessionToken(),
      },
      body: JSON.stringify(params),
    });

    el.classList.remove("loading");

    if (!json) {
      return;
    }
    if (!json.status) {
      alert("error: " + json.error);
      return;
    }
  },
};
